// src/components/recommendations/recommendations.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n    theme\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSBadgeFragment on EGDSBadge {\n    ...EGDSStandardBadgeFragment\n  }\n\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardBadgesFragment on ActivityCardBadges {\n    primary {\n      ...EGDSBadgeFragment\n    }\n    secondary {\n      ...EGDSBadgeFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSPriceLockupFragment on EGDSPriceLockup {\n    isPointsFirst\n    accessibilityPrice\n    accessibilityStrikeThroughDialogTrigger\n    leadingCaption\n    lockupFormattedPoints\n    lockupPrice\n    priceSubtextFirst\n    priceSubtextStandard\n    strikeThroughPrice\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    headingType\n    accessibility\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    size\n    text\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n    decorative\n    textSize: size\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment ActivityPriceDisplayFragment on ActivityPriceDisplay {\n    header {\n      ...EGDSTextFragment\n    }\n    footer {\n      ...EGDSTextFragment\n    }\n    priceLockup {\n      ...EGDSPriceLockupFragment\n    }\n    disclaimer {\n      contents {\n        ...EGDSTextFragment\n      }\n      dialog {\n        closeAnalytics {\n          linkName\n          referrerId\n        }\n        footer {\n          buttons {\n            primary\n            accessibility\n            disabled\n          }\n        }\n      }\n      trigger {\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment ActivitySaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    viewType {\n      ...TripSaveItemViewTypeFragment\n    }\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n    coachmark {\n      ...TripsCoachmarkFragment\n    }\n    tripId\n  }\n\n  fragment TripsCoachmarkFragment on TripsCoachmark {\n    body\n    button {\n      accessibility\n      analytics {\n        ...ClientSideEventAnalyticsFragment\n      }\n      primary\n      disabled\n    }\n    impressionAnalytics {\n      ...ClientSideImpressionEventAnalyticsFragment\n    }\n    dismissEventAnalytics {\n      ...ClientSideEventAnalyticsFragment\n    }\n    title\n  }\n  fragment ClientSideEventAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n  }\n  fragment ClientSideImpressionEventAnalyticsFragment on ClientSideImpressionEventAnalytics {\n    linkName\n    referrerId\n    event\n  }\n\n  fragment TripSaveItemViewTypeFragment on TripSaveItemViewType {\n    ... on TripSaveItemHeartView {\n      heartOutlineType\n    }\n    ... on TripSaveItemButtonView {\n      ...TripSaveItemItemButtonViewFragment\n    }\n  }\n\n  fragment TripSaveItemItemButtonViewFragment on TripSaveItemButtonView {\n    button {\n      ... on TripSaveItemButton {\n        ...UIPrimaryButtonFragment\n        ...UISecondaryButtonFragment\n      }\n    }\n  }\n\n  fragment UIPrimaryButtonFragment on UIPrimaryButton {\n    accessibility\n    disabled\n    primary\n  }\n\n  fragment UISecondaryButtonFragment on UISecondaryButton {\n    accessibility\n    disabled\n    primary\n  }\n\n  fragment TripsSaveItemAttributesFragment on TripsSaveItemAttributes {\n    ...TripsSaveStayAttributesFragment\n    ...TripsSaveActivityAttributesFragment\n    ...TripsSaveFlightSearchAttributesFragment\n    ...TripsSaveCarOfferAttributesFragment\n    ...TripsSavePackageAttributesFragment\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    label\n    tooltip\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  fragment TripsSavePackageAttributesFragment on TripsSavePackageAttributes {\n    packageOfferId\n    sessionId\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment ActivityClickActionFragment on ActivityClickAction {\n    ... on ActivityLinkClickAction {\n      accessibilityText\n      analytics {\n        linkName\n        referrerId\n      }\n      linkTagUrl\n      opensInNewTab\n    }\n  }\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expandedAccessibilityText\n    collapsedAccessibilityText\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expanded\n  }\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expanded\n  }\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment EGDSExpandoFragment on EGDSExpando {\n    ... on EGDSExpandoPeek {\n      ...EGDSExpandoPeekFragment\n    }\n    ... on EGDSExpandoListItem {\n      ...EGDSExpandoListItemFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardTextContentFragment on ActivityCardTextContent {\n    expando {\n      ...EGDSExpandoFragment\n    }\n    heading {\n      ...EGDSTextFragment\n    }\n    items {\n      ...EGDSTextFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardHeadingContentFragment on ActivityCardHeadingContent {\n    heading {\n      ...EGDSTextFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment EarnMessageContainerListItemFragment on EarnMessageContainerListItem {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    stylizedText {\n      ...EGDSSpannableTextFragment\n    }\n    style\n    text\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextIconLinkListItemFragment on EGDSTextIconLinkListItem {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {\n    text\n  }\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n    nestedList {\n      listItems {\n        ... on EGDSTextStandardListItem {\n          text\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextWithMarkListItemFragment on EGDSTextWithMarkListItem {\n    mark {\n      ...EGDSMarkFragment\n    }\n    style\n    text\n  }\n\n  ", "\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextListItemFragment on EGDSTextListItem {\n    ...EGDSTextStandardListItemFragment\n    ...EGDSTextIconListItemFragment\n    ...EGDSTextIconLinkListItemFragment\n    ...EGDSTextWithMarkListItemFragment\n    ...EarnMessageContainerListItemFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment EGDSBulletedListFragment on EGDSBulletedList {\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n    size\n  }\n\n  ", "\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextIconListFragment on EGDSTextIconList {\n    listItems {\n      ...EGDSTextIconListItemFragment\n    }\n    size\n  }\n\n  ", "\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment EGDSUnorderedListFragment on EGDSUnorderedList {\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n    size\n  }\n\n  ", "\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextListFragment on EGDSTextList {\n    ... on EGDSUnorderedList {\n      ...EGDSUnorderedListFragment\n    }\n    ... on EGDSBulletedList {\n      ...EGDSBulletedListFragment\n    }\n    ... on EGDSTextIconList {\n      ...EGDSTextIconListFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment EGDSLinkListFragment on EGDSLinkList {\n    listItems {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardTextListContentFragment on ActivityCardTextListContent {\n    expando {\n      ...EGDSExpandoFragment\n    }\n    icon {\n      ...EGDSGraphicFragment\n    }\n    heading {\n      ...EGDSTextFragment\n    }\n    list {\n      ...EGDSTextListFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardLinkListContentFragment on ActivityCardLinkListContent {\n    heading {\n      ...EGDSHeadingFragment\n    }\n    list {\n      ...EGDSLinkListFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    ... on EGDSTravelerStepInput {\n      egdsElementId\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    decreaseText\n    increaseText\n    label\n    key\n    max\n    min\n    step\n    subLabel\n    value\n  }\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment EGDSDialogFooterButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n  }\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment EGDSDialogFooterFragment on EGDSDialogFooter {\n    ... on EGDSInlineDialogFooter {\n      buttons {\n        ...EGDSDialogFooterButtonFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerContentFragment on EGDSDatePickerContent {\n    accessibility\n    dateKey\n    text\n    theme\n  }\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonActionFragment on UIAction {\n    analytics {\n      linkName\n      referrerId\n    }\n\n    ... on ActivityOpenOffersModalAction {\n      activityId\n      dateRange {\n        startDate {\n          day\n          month\n          year\n        }\n        endDate {\n          day\n          month\n          year\n        }\n      }\n      dismissButtonAccessibility\n      dismissButtonAnalytics {\n        linkName\n        referrerId\n      }\n      selectedOffers {\n        offerProductNaturalKey\n      }\n      heading {\n        ...EGDSHeadingFragment\n      }\n      subHeading {\n        ...EGDSPlainTextFragment\n      }\n    }\n\n    ... on ActivityAddOfferToTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityRemoveOffersFromTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKeys {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityUpdateOfferInTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      newOfferNaturalKey {\n        offerProductNaturalKey\n      }\n      oldOfferNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    action {\n      ...EGDSButtonActionFragment\n    }\n    icon {\n      description\n      id\n      title\n    }\n  }\n\n  ", "\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment ActivityDialogTriggerFragment on ActivityDialogTrigger {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n\n    ... on ActivityButtonDialogTrigger {\n      button {\n        ...EGDSButtonFragment\n      }\n    }\n\n    ... on ActivityGraphicDialogTrigger {\n      graphic {\n        ...EGDSGraphicFragment\n      }\n    }\n\n    ... on ActivityLinkDialogTrigger {\n      linkGraphic: graphic {\n        ...EGDSGraphicFragment\n      }\n      label\n    }\n\n    ... on ActivityFakeInputDialogTrigger {\n      icon {\n        id\n      }\n      label\n      value\n    }\n\n    ... on ActivityMapDialogTrigger {\n      staticMapImage {\n        accessibility\n        url\n      }\n      mapTriggerLabel: label\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment ActivityDateRangePickerDialogFragment on ActivityDateRangePickerDialog {\n    dateRangePicker {\n      buttonText\n      dateFormat\n      firstDayOfWeek\n      footerText\n      sameDaySelectionAllowed\n      selectedEndDate {\n        ...DateFragment\n      }\n      selectedStartDate {\n        ...DateFragment\n      }\n      validDaysLowerBoundInclusive {\n        ...DateFragment\n      }\n      validDaysUpperBoundInclusive {\n        ...DateFragment\n      }\n      datePickerContent {\n        ...EGDSDatePickerContentFragment\n      }\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment ActivityClickActionsFragment on ActivityClickAction {\n    accessibilityText\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n    ... on ActivityLinkClickAction {\n      linkTagUrl\n      opensInNewTab\n    }\n\n    ... on ActivityRefClickAction {\n      sectionRef\n    }\n\n    ... on ActivitySelectionClickAction {\n      selectionList {\n        id\n        value\n      }\n    }\n    ... on ActivityPaginationInfoAction {\n      pagination {\n        size\n        startingIndex\n      }\n    }\n  }\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment ActivityDisclaimerDialogFragment on ActivityDisclaimerDialog {\n    contents {\n      ...EGDSTextFragment\n    }\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      footer {\n        ...EGDSDialogFooterFragment\n      }\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n    dialogActions {\n      ...ActivityClickActionsFragment\n    }\n  }\n\n  ", "\n  ", "\n\n  ", "\n  ", "\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment ActivityTravelerSelectorDialogFragment on ActivityTravelerSelectorDialog {\n    heading {\n      ...EGDSHeadingFragment\n    }\n    doneButton {\n      primary\n      action {\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    ticketsStepInput {\n      ...EGDSTravelerStepInputFragment\n    }\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n    errorMessageForSelectedTickets {\n      ...EGDSGraphicTextFragment\n    }\n  }\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRadioButtonFragment on EGDSBasicRadioButton {\n    description\n    disabled\n    label\n    labelSuffix\n    value\n  }\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment EGDSRadioButtonFragment on EGDSRadioButton {\n    ... on EGDSBasicRadioButton {\n      ...EGDSBasicRadioButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRadioGroupFragment on EGDSBasicRadioGroup {\n    groupName\n    selected\n    options {\n      ...EGDSRadioButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  fragment ActivityRadioGroupDialogFragment on ActivityRadioGroupDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    doneButton {\n      primary\n      action {\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    heading {\n      ...EGDSHeadingFragment\n    }\n    radioGroup {\n      ...EGDSBasicRadioGroupFragment\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n  }\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewsCommentFragment on ActivityReview {\n    text\n    author\n    formattedActivityDate\n    overallScoreMessage {\n      ...EGDSTextFragment\n    }\n    formattedSubmissionDate\n    reviewedOn\n    userLocation\n    expando {\n      ...EGDSExpandoFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewsSortTabFragment on ActivityTabbedNavigationBar {\n    heading\n    tabs {\n      label\n      selected\n      clickAction {\n        ...ActivityClickActionsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject61() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewsSummaryFragment on ActivityReviewsSummary {\n    averageScore {\n      ...EGDSTextFragment\n    }\n    disclaimer {\n      ...ActivityDisclaimerDialogFragment\n    }\n    sectionRef\n    reviewSuperlative {\n      size\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject61 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject62() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewsMoreButtonFragment on ActivityReviewsPaginationButton {\n    action {\n      ...ActivityClickActionsFragment\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject62 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject63() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewsDialogContentFragment on ActivityReviewListComponent {\n    comments {\n      ...ActivityReviewsCommentFragment\n    }\n    summary {\n      ...ActivityReviewsSummaryFragment\n    }\n    sortTabs {\n      ...ActivityReviewsSortTabFragment\n    }\n    moreButton {\n      ...ActivityReviewsMoreButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject63 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject64() {
  var data = _tagged_template_literal(["\n  fragment ActivityReviewCommentsDialogFragment on ActivityReviewCommentsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject64 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject65() {
  var data = _tagged_template_literal(["\n  fragment ActivityMapPlaceCardFragment on ActivityMapPlaceCard {\n    image {\n      description\n      url\n    }\n    primary {\n      ...EGDSTextFragment\n    }\n    secondaries {\n      ...EGDSTextFragment\n    }\n    tag {\n      ...EGDSTextFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject65 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject66() {
  var data = _tagged_template_literal(["\n  fragment MapMarkersFragment on ActivityMapMarker {\n    markerType\n    markerIconType\n    markerStatus\n    markerPosition {\n      latitude\n      longitude\n    }\n    text\n    placeCard {\n      ...ActivityMapPlaceCardFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject66 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject67() {
  var data = _tagged_template_literal(["\n  fragment EGDSDynamicMapConfigFragment on EGDSDynamicMapConfig {\n    accessToken\n    egdsMapProvider\n  }\n"]);
  _templateObject67 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject68() {
  var data = _tagged_template_literal(["\n  fragment ActivityMapFragment on ActivityMap {\n    __typename\n    egMap {\n      center {\n        latitude\n        longitude\n      }\n      config {\n        ...EGDSDynamicMapConfigFragment\n      }\n    }\n    markers {\n      ...MapMarkersFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject68 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject69() {
  var data = _tagged_template_literal(["\n  fragment ActivityLocationMapDialogFragment on ActivityLocationMapDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...ActivityDialogTriggerFragment\n    }\n    dynamicMap {\n      ...ActivityMapFragment\n    }\n  }\n\n  ", "\n\n  ", "\n  ", "\n"]);
  _templateObject69 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject70() {
  var data = _tagged_template_literal(["\n  fragment SignInActivityActionDialogFragment on EGDSActionDialog {\n    closeAnalytics {\n      referrerId\n      linkName\n    }\n    footer {\n      ... on EGDSStackedDialogFooter {\n        buttons {\n          ... on EGDSOverlayButton {\n            __typename\n          }\n        }\n      }\n      ... on EGDSInlineDialogFooter {\n        buttons {\n          ... on UIPrimaryButton {\n            accessibility\n            primary\n            disabled\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n            }\n          }\n          ... on UITertiaryButton {\n            accessibility\n            primary\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n              }\n            }\n            disabled\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject70 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject71() {
  var data = _tagged_template_literal(["\n  fragment SignInActivityDialogFragment on EGDSDialog {\n    ...SignInActivityActionDialogFragment\n  }\n  ", "\n"]);
  _templateObject71 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject72() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardReviewsRatingContentFragment on ActivityCardReviewsRatingContent {\n    primary {\n      ...EGDSTextFragment\n    }\n    secondaries {\n      ...EGDSTextFragment\n    }\n    disclaimer {\n      ...ActivityDisclaimerDialogFragment\n    }\n    reviewRatingBadge {\n      text\n      theme\n      accessibility\n      size\n    }\n    reviewSuperlative {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject72 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject73() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardSectionContentFragment on ActivityCardSectionContent {\n    rows {\n      ...ActivityCardTextContentFragment\n      ...ActivityCardTextListContentFragment\n      ...ActivityCardHeadingContentFragment\n      ...ActivityCardReviewsRatingContentFragment\n      ...ActivityPriceDisplayFragment\n      ...ActivityCardLinkListContentFragment\n    }\n    columns {\n      rows {\n        ...ActivityCardTextContentFragment\n        ...ActivityCardTextListContentFragment\n        ...ActivityCardHeadingContentFragment\n        ...ActivityCardReviewsRatingContentFragment\n        ...ActivityPriceDisplayFragment\n        ...ActivityCardLinkListContentFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject73 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject74() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardHtmlContentFragment on ActivityCardHtmlContent {\n    expando {\n      ...EGDSExpandoFragment\n    }\n    heading {\n      ...EGDSTextFragment\n    }\n    text\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject74 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject75() {
  var data = _tagged_template_literal(["\n  fragment ActivityImageHeaderCardFragment on ActivityImageHeaderCard {\n    analytics {\n      linkName\n      referrerId\n    }\n    badges {\n      ...ActivityCardBadgesFragment\n    }\n    clickAction {\n      ...ActivityClickActionFragment\n    }\n    contents {\n      ... on ActivityCardSectionContent {\n        ...ActivityCardSectionContentFragment\n      }\n      ... on ActivityPriceDisplay {\n        ...ActivityPriceDisplayFragment\n      }\n    }\n    image {\n      description\n      url\n    }\n    saveItem {\n      ...ActivitySaveItemFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject75 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject76() {
  var data = _tagged_template_literal(["\n  fragment ActivityLocationCardFragment on ActivityLocationCard {\n    heading {\n      ...EGDSTextFragment\n    }\n    mapContents: contents {\n      ...ActivityCardSectionContentFragment\n    }\n    map {\n      ...ActivityLocationMapDialogFragment\n    }\n    ref: sectionRef\n  }\n\n  ", "\n\n  ", "\n  ", "\n"]);
  _templateObject76 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject77() {
  var data = _tagged_template_literal(["\n  fragment ActivityCardFragment on ActivityCard {\n    ...ActivityImageHeaderCardFragment\n    ...ActivityLocationCardFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject77 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject78() {
  var data = _tagged_template_literal(["\n  fragment ActivityCarouselContainerFragment on ActivityCarouselContainer {\n    heading {\n      ...EGDSHeadingFragment\n    }\n    accessibility {\n      ... on ActivityCarouselAccessibilityData {\n        label\n        prevButton\n        nextButton\n      }\n    }\n    cards {\n      ...ActivityCardFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject78 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject79() {
  var data = _tagged_template_literal(["\n  query RecommendationsQuery(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n  ) {\n    activityInfo(context: $context, activityId: $activityId, dateRange: $dateRange, destination: $destination) {\n      recommendations {\n        carousel {\n          ...ActivityCarouselContainerFragment\n        }\n        heading {\n          ...EGDSHeadingFragment\n        }\n      }\n    }\n  }\n\n  ", "\n\n  ", "\n"]);
  _templateObject79 = function _templateObject() {
    return data;
  };
  return data;
}
import React72 from "react";
import { gql as gql80, useQuery } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
// ../internal/src/components/activitiy-carousel-container/activity-carousel-container.tsx
import React71 from "react";
import { gql as gql79 } from "@apollo/client";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
// ../internal/src/components/activity-card/activity-card.tsx
import React70 from "react";
import { gql as gql78 } from "@apollo/client";
// ../internal/src/components/activity-card/activity-image-header-card.tsx
import React68 from "react";
import { gql as gql76 } from "@apollo/client";
import { EGDSCard as EGDSCard3, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign4 } from "@egds/react-core/price-lockup";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { ReactPortalProvider } from "@shared-ui/portal-context";
// ../internal/src/components/activity-card-badges/activity-card-badges.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSBadgeSize } from "@egds/react-core/badge";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
// ../internal/src/components/egds-badge/egds-badge.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSBadge, EGDSBadgeLoyalty } from "@egds/react-core/badge";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var __EGDSIconFragment = gql(_templateObject());
var ActivitiesEGDSIcon = function (param) {
  var className = param.className,
    data = param.data;
  var _data_title, _data_theme;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    className: className,
    description: data.description,
    id: Math.random().toString(),
    name: data.id,
    size: data.size ? EGDSIconSize[data.size] : void 0,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: Boolean(data.withBackground)
  });
};
ActivitiesEGDSIcon.displayName = "ActivitiesEGDSIcon";
ActivitiesEGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var __EGDSMarkFragment = gql2(_templateObject1());
var ActivitiesEGDSMark = function (param) {
  var className = param.className,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React2.createElement(EGDSMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? EGDSMarkSize[data.markSize] : void 0,
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
ActivitiesEGDSMark.displayName = "ActivitiesEGDSMark";
ActivitiesEGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
var __EGDSGraphicFragment = gql3(_templateObject2(), ActivitiesEGDSIcon.fragment, ActivitiesEGDSMark.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React3.createElement(ActivitiesEGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React3.createElement(ActivitiesEGDSMark, {
        className: className,
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-badge/__private/badge-theme.ts
import { EGDSBadgeLoyaltyThemes, EGDSBadgeTheme } from "@egds/react-core/badge";
var badgeThemeToEGDSTheme = {
  DEAL_BUNDLED: EGDSBadgeTheme.DEAL_BUNDLED,
  DEAL_GENERIC: EGDSBadgeTheme.DEAL_GENERIC,
  DEAL_MEMBER: EGDSBadgeTheme.DEAL_MEMBER,
  NOTIFICATION_1: EGDSBadgeTheme.NOTIFICATION_1,
  NOTIFICATION_2: EGDSBadgeTheme.NOTIFICATION_2,
  VIP: EGDSBadgeTheme.VIP,
  LOYALTY_HIGH_TIER: EGDSBadgeTheme.LOYALTY_HIGH_TIER,
  LOYALTY_MIDDLE_TIER: EGDSBadgeTheme.LOYALTY_MIDDLE_TIER,
  LOYALTY_LOW_TIER: EGDSBadgeTheme.LOYALTY_LOW_TIER,
  SPONSORED: EGDSBadgeTheme.SPONSORED,
  VIEWED: EGDSBadgeTheme.VIEWED,
  SAVED: EGDSBadgeTheme.SAVED,
  FAMILY_FRIENDLY: EGDSBadgeTheme.FAMILY_FRIENDLY,
  SUPPLIER_PROMO: EGDSBadgeTheme.SUPPLIER_PROMO
};
var loyaltyBadgeThemeToEGDSTheme = {
  GLOBAL_LOW_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_LOW
};
// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var __EGDSStandardBadgeFragment = gql4(_templateObject3(), EGDSGraphic.fragment);
var EGDSStandardBadge = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var graphic = data.graphic,
    text = data.text,
    theme = data.theme;
  if (!text) {
    return null;
  }
  if (theme && loyaltyBadgeThemeToEGDSTheme[theme]) {
    return /* @__PURE__ */React4.createElement(EGDSBadgeLoyalty, {
      className: className,
      size: size,
      theme: loyaltyBadgeThemeToEGDSTheme[theme],
      text: text
    }, graphic && /* @__PURE__ */React4.createElement(EGDSGraphic, {
      data: graphic
    }));
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */
    React4.createElement(EGDSBadge, {
      className: className,
      size: size,
      theme: theme ? badgeThemeToEGDSTheme[theme] : void 0,
      text: text
    }, graphic && /* @__PURE__ */React4.createElement(EGDSGraphic, {
      data: graphic
    }))
  );
};
EGDSStandardBadge.fragment = __EGDSStandardBadgeFragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/egds-badge/egds-badge.tsx
var __EGDSBadgeFragment = gql5(_templateObject4(), EGDSStandardBadge.fragment);
var ActivitiesEGDSBadge = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStandardBadge":
      return /* @__PURE__ */React5.createElement(EGDSStandardBadge, {
        className: className,
        size: size,
        data: data
      });
    default:
      return null;
  }
};
ActivitiesEGDSBadge.fragment = __EGDSBadgeFragment;
ActivitiesEGDSBadge.displayName = "ActivitiesEGDSBadge";
// ../internal/src/components/activity-card-badges/activity-card-badges.tsx
var __Fragment = gql6(_templateObject5(), ActivitiesEGDSBadge.fragment);
var ActivityCardBadges = function (param) {
  var _param_primaryPosition = param.primaryPosition,
    primaryPosition = _param_primaryPosition === void 0 ? {
      left: "two",
      top: "two"
    } : _param_primaryPosition,
    _param_secondaryPosition = param.secondaryPosition,
    secondaryPosition = _param_secondaryPosition === void 0 ? {
      right: "two",
      bottom: "minus-three"
    } : _param_secondaryPosition,
    _param_hidePrimary = param.hidePrimary,
    hidePrimary = _param_hidePrimary === void 0 ? false : _param_hidePrimary,
    data = param.data;
  if (!data || !(data.primary || data.secondary)) {
    return null;
  }
  var primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, primary && !hidePrimary && /* @__PURE__ */React6.createElement(EGDSLayoutPosition, {
    position: primaryPosition,
    type: "absolute"
  }, /* @__PURE__ */React6.createElement(ActivitiesEGDSBadge, {
    size: EGDSBadgeSize.LARGE,
    data: primary
  })), secondary && /* @__PURE__ */React6.createElement(EGDSLayoutPosition, {
    position: secondaryPosition,
    type: "absolute"
  }, /* @__PURE__ */React6.createElement(ActivitiesEGDSBadge, {
    size: EGDSBadgeSize.LARGE,
    data: secondary
  })));
};
ActivityCardBadges.displayName = "ActivityCardBadges";
ActivityCardBadges.fragment = __Fragment;
// ../internal/src/components/activity-price-display/activity-price-display.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-price-lockup/egds-price-lockup.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSPriceLockup } from "@egds/react-core/price-lockup";
var __Fragment2 = gql7(_templateObject6());
var ActivitiesEGDSPriceLockup = function (param) {
  var className = param.className,
    align = param.align,
    openStrikeThroughDialog = param.openStrikeThroughDialog,
    data = param.data,
    isStrikeThroughFirst = param.isStrikeThroughFirst,
    triggerRef = param.triggerRef;
  var accessibilityPrice = data.accessibilityPrice,
    accessibilityStrikeThroughDialogTrigger = data.accessibilityStrikeThroughDialogTrigger,
    leadingCaption = data.leadingCaption,
    lockupFormattedPoints = data.lockupFormattedPoints,
    lockupPrice = data.lockupPrice,
    priceSubtextFirst = data.priceSubtextFirst,
    priceSubtextStandard = data.priceSubtextStandard,
    strikeThroughPrice = data.strikeThroughPrice,
    isPointsFirst = data.isPointsFirst;
  return /* @__PURE__ */React7.createElement(EGDSPriceLockup, {
    align: align,
    isPointsFirst: isPointsFirst !== null && isPointsFirst !== void 0 ? isPointsFirst : false,
    a11yPrice: accessibilityPrice,
    className: className,
    lockupFormattedPoints: lockupFormattedPoints !== null && lockupFormattedPoints !== void 0 ? lockupFormattedPoints : void 0,
    lockupPrice: lockupPrice !== null && lockupPrice !== void 0 ? lockupPrice : void 0,
    leadingCaption: leadingCaption !== null && leadingCaption !== void 0 ? leadingCaption : void 0,
    priceSubtextFirst: _to_consumable_array(priceSubtextFirst || []),
    priceSubtextStandard: _to_consumable_array(priceSubtextStandard || []),
    strikeThroughPrice: strikeThroughPrice !== null && strikeThroughPrice !== void 0 ? strikeThroughPrice : void 0,
    a11yStrikeThroughDialogTrigger: accessibilityStrikeThroughDialogTrigger !== null && accessibilityStrikeThroughDialogTrigger !== void 0 ? accessibilityStrikeThroughDialogTrigger : void 0,
    strikeThroughTrigger: !!openStrikeThroughDialog && /* @__PURE__ */React7.createElement("button", {
      ref: triggerRef,
      onClick: openStrikeThroughDialog,
      type: "button",
      className: "uitk-more-info-trigger"
    }),
    isStrikeThroughFirst: isStrikeThroughFirst
  });
};
ActivitiesEGDSPriceLockup.displayName = "ActivitiesEGDSPriceLockup";
ActivitiesEGDSPriceLockup.fragment = __Fragment2;
// ../internal/src/components/egds-text/egds-heading.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSHeading } from "@egds/react-core/text";
var _obj;
// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = (_obj = {}, _define_property(_obj, "H1" /* H1 */, "h1"), _define_property(_obj, "H2" /* H2 */, "h2"), _define_property(_obj, "H3" /* H3 */, "h3"), _define_property(_obj, "H4" /* H4 */, "h4"), _define_property(_obj, "H5" /* H5 */, "h5"), _define_property(_obj, "H6" /* H6 */, "h6"), _define_property(_obj, "H7" /* H7 */, "h6"), _define_property(_obj, "H8" /* H8 */, "h6"), _obj);
// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql8(_templateObject7());
var ActivitiesEGDSHeading = function (param) {
  var className = param.className,
    align = param.align,
    size = param.size,
    tag = param.tag,
    data = param.data,
    tabIndex = param.tabIndex;
  var headingType = data.headingType,
    text = data.text,
    accessibility = data.accessibility;
  var headingTag = tag !== null && tag !== void 0 ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, /* @__PURE__ */React8.createElement(EGDSHeading, {
    className: className,
    align: align,
    tag: tag !== null && tag !== void 0 ? tag : headingTag,
    size: size,
    tabIndex: tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React8.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
ActivitiesEGDSHeading.fragment = fragment;
ActivitiesEGDSHeading.displayName = "ActivitiesEGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var _obj1;
// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = (_obj1 = {}, _define_property(_obj1, "P1" /* P1 */, 1), _define_property(_obj1, "P2" /* P2 */, 2), _define_property(_obj1, "P3" /* P3 */, 3), _obj1);
// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql9(_templateObject8());
var ActivitiesEGDSParagraph = function (param) {
  var className = param.className,
    data = param.data;
  var text = data.text,
    style = data.style;
  return /* @__PURE__ */React9.createElement(EGDSParagraph, {
    className: className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
ActivitiesEGDSParagraph.fragment = fragment2;
ActivitiesEGDSParagraph.displayName = "ActivitiesEGDSParagraph";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var _obj2;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
var _obj3;
var UILinkTargetMap = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self"), _obj3);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql10(_templateObject9(), ActivitiesEGDSIcon.fragment);
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React10.createElement(ActivitiesEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    useRelativePath = _param_data_action.useRelativePath,
    disabled = _param_data.disabled,
    iconPosition = _param_data.iconPosition,
    standardLinkIcon = _param_data.standardLinkIcon,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker();
  var onClick = React10.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  var getPath = React10.useCallback(function () {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React10.createElement(EGDSLink, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    align: align
  }, /* @__PURE__ */React10.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React10.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React10.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React10.createElement(EGDSText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-text.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment4 = gql11(_templateObject10(), EGDSGraphic.fragment);
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var graphic = data.graphic,
    text = data.text;
  return /* @__PURE__ */React11.createElement(EGDSLayoutFlex, {
    className: className
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React11.createElement(EGDSSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React11.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React11.createElement(EGDSSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React11.createElement(EGDSText2, {
    size: size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-icon-text.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment5 = gql12(_templateObject11(), ActivitiesEGDSIcon.fragment);
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React12.createElement(EGDSLayoutFlex2, {
    className: className
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React12.createElement(ActivitiesEGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React12.createElement(EGDSSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React12.createElement(EGDSText3, {
    size: size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment6 = gql13(_templateObject12());
var EGDSInlineLink = function (param) {
  var className = param.className,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    disabled = _param_data.disabled,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker2();
  var onClick = React13.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React13.createElement(EGDSLink2, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled: disabled,
    inline: true
  }, /* @__PURE__ */React13.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React13.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment7 = gql14(_templateObject13());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React14.createElement(EGDSText4, {
    whiteSpace: "pre-line",
    className: className,
    align: align,
    size: size,
    inline: inline,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
var _obj4;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj4 = {}, _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj4, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj4, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj4, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj4, "INVERSE" /* INVERSE */, "inverse"), _obj4);
var _obj5;
var EGDSTextThemeMapper = (_obj5 = {}, _define_property(_obj5, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj5, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj5, "DEFAULT" /* DEFAULT */, "default"), _obj5);
var _obj6;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */, "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */, "regular"), _obj6);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql15(_templateObject14());
var EGDSStylizedText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    weight = data.weight,
    accessibility = data.accessibility,
    decorative = data.decorative;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  var RenderText = function () {
    return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(EGDSText5, {
      className: className,
      align: align,
      inline: inline,
      size: size,
      theme: themeProps,
      weight: weightProps,
      "aria-hidden": accessibility !== null
    }, text), accessibility && /* @__PURE__ */React15.createElement("span", {
      className: "is-visually-hidden"
    }, accessibility));
  };
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React15.createElement("s", null, /* @__PURE__ */React15.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React15.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql16(_templateObject15(), EGDSStylizedText.fragment, EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React16.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React16.createElement(EGDSGraphicText, {
        className: className,
        data: data,
        size: size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React16.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        align: align,
        inline: true,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql17(_templateObject16(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_contents, _data_inlineContent, _data_inlineContent1;
  var align = props.align,
    headingSize = props.headingSize,
    data = props.data,
    theme = props.theme,
    styleProps = _object_without_properties(props, ["align", "headingSize", "data", "theme"]);
  if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
    return /* @__PURE__ */React17.createElement(EGDSText6, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align,
      theme: theme
    }), data.text);
  }
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
    return /* @__PURE__ */React17.createElement(React17.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React17.createElement(React17.Fragment, null, /* @__PURE__ */React17.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        align: align,
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index),
        theme: theme
      })), " ");
    }));
  }
  return /* @__PURE__ */React17.createElement(React17.Fragment, null, data.contents.map(function (item, index) {
    return /* @__PURE__ */React17.createElement(React17.Fragment, {
      key: "spannable-item-".concat(index)
    }, /* @__PURE__ */React17.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
      data: item
    }, styleProps), {
      headingSize: headingSize,
      theme: theme
    })), " ");
  }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql18(_templateObject17(), ActivitiesEGDSHeading.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSIconText.fragment, EGDSGraphicText.fragment, ActivitiesEGDSParagraph.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment, EGDSSpannableText.fragment);
var ActivitiesEGDSText = function (param) {
  var className = param.className,
    headingAlign = param.headingAlign,
    headingSize = param.headingSize,
    headingTag = param.headingTag,
    textAlign = param.textAlign,
    textSize = param.textSize,
    align = param.align,
    inline = param.inline,
    tabIndex = param.tabIndex,
    theme = param.theme,
    data = param.data;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React18.createElement(ActivitiesEGDSHeading, {
        className: className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data: data,
        tabIndex: tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React18.createElement(EGDSPlainText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline,
        theme: theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React18.createElement(EGDSStylizedText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React18.createElement(EGDSGraphicText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React18.createElement(EGDSIconText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React18.createElement(ActivitiesEGDSParagraph, {
        className: className,
        data: data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React18.createElement(EGDSStandardLink, {
        className: className,
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React18.createElement(EGDSInlineLink, {
        className: className,
        data: data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React18.createElement(EGDSSpannableText, {
        className: className,
        size: textSize,
        headingSize: headingSize,
        data: data,
        align: align,
        theme: theme
      });
    default:
      return null;
  }
};
ActivitiesEGDSText.fragment = fragment11;
ActivitiesEGDSText.displayName = "ActivitiesEGDSText";
// ../internal/src/components/activity-price-display/__private/price-display-align-mapper.ts
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign2 } from "@egds/react-core/price-lockup";
var _obj7;
var priceDisplayAlignMapper = (_obj7 = {}, _define_property(_obj7, EGDSPriceLockupAlign2.LEFT, "left"), _define_property(_obj7, EGDSPriceLockupAlign2.RIGHT, "right"), _obj7);
// ../internal/src/components/activity-price-display/activity-price-display.tsx
var __Fragment3 = gql19(_templateObject18(), ActivitiesEGDSText.fragment, ActivitiesEGDSPriceLockup.fragment);
var headerMargin = {
  blockstart: "one"
};
var priceLockupMargin = {
  blockstart: "one"
};
var footerMargin = {
  blockstart: "one"
};
var ActivityPriceDisplay = function (param) {
  var className = param.className,
    data = param.data,
    align = param.align,
    isStrikeThroughFirst = param.isStrikeThroughFirst;
  var _disclaimer_dialog_footer_buttons_;
  var priceLockup = data.priceLockup,
    header = data.header,
    footer = data.footer,
    disclaimer = data.disclaimer;
  var clickTracker = useClickTracker3();
  var dialogKey = React19.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var _useDialog = _sliced_to_array(useDialog("activity-price-disclaimer-".concat(dialogKey), "priceDisclaimeriDialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var openPriceDisclaimerDialog = function () {
    dialogActions.openDialog();
    if ((disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.trigger.__typename) === "ActivityGraphicDialogTrigger") {
      clickTracker(disclaimer.trigger.analytics.referrerId, disclaimer.trigger.analytics.linkName);
    }
  };
  var closePriceDisclaimerDialog = function () {
    dialogActions.closeDialog();
    if (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.dialog.closeAnalytics) {
      clickTracker(disclaimer.dialog.closeAnalytics.referrerId, disclaimer.dialog.closeAnalytics.linkName);
    }
  };
  var triggerRef = React19.useRef(null);
  var _disclaimer_dialog_footer_buttons__primary;
  return priceLockup && /* @__PURE__ */React19.createElement("section", {
    className: className
  }, (header === null || header === void 0 ? void 0 : header.length) && header.map(function (headerText, index) {
    return /* @__PURE__ */React19.createElement(EGDSSpacing3, {
      key: "activity-price-info-header-".concat(index),
      margin: headerMargin
    }, /* @__PURE__ */React19.createElement(ActivitiesEGDSText, {
      textAlign: align && priceDisplayAlignMapper[align],
      textSize: 200,
      data: headerText
    }));
  }), /* @__PURE__ */React19.createElement(EGDSSpacing3, {
    margin: priceLockupMargin
  }, /* @__PURE__ */React19.createElement(ActivitiesEGDSPriceLockup, {
    openStrikeThroughDialog: disclaimer ? openPriceDisclaimerDialog : void 0,
    align: align,
    data: priceLockup,
    isStrikeThroughFirst: isStrikeThroughFirst,
    triggerRef: triggerRef
  })), (footer === null || footer === void 0 ? void 0 : footer.length) && footer.map(function (footerText, index) {
    return /* @__PURE__ */React19.createElement(EGDSSpacing3, {
      key: "activity-price-info-header-".concat(index),
      margin: footerMargin
    }, /* @__PURE__ */React19.createElement(ActivitiesEGDSText, {
      textAlign: align && priceDisplayAlignMapper[align],
      textSize: 200,
      data: footerText
    }));
  }), disclaimer && /* @__PURE__ */React19.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React19.createElement(DialogComponent, null, /* @__PURE__ */React19.createElement(EGDSDialog, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React19.createElement(EGDSDialogContent, null, disclaimer.contents.map(function (content, index) {
    return /* @__PURE__ */React19.createElement(ActivitiesEGDSText, {
      key: "activity-price-disclaimer-contents-".concat(index),
      data: content
    });
  }), /* @__PURE__ */React19.createElement(EGDSDialogFooter, {
    buttonOne: {
      onClick: closePriceDisclaimerDialog,
      text: (_disclaimer_dialog_footer_buttons__primary = (_disclaimer_dialog_footer_buttons_ = disclaimer.dialog.footer.buttons[0]) === null || _disclaimer_dialog_footer_buttons_ === void 0 ? void 0 : _disclaimer_dialog_footer_buttons_.primary) !== null && _disclaimer_dialog_footer_buttons__primary !== void 0 ? _disclaimer_dialog_footer_buttons__primary : "",
      type: "tertiary"
    }
  }))))));
};
ActivityPriceDisplay.displayName = "ActivityPriceDisplay";
ActivityPriceDisplay.fragment = __Fragment3;
// ../internal/src/components/activity-trip-save-item/activity-trips-save-item.tsx
import React20 from "react";
import { gql as gql24 } from "@apollo/client";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/__fragments/common/date-fragment.ts
import { gql as gql20 } from "@apollo/client";
var __DateFragment = gql20(_templateObject19());
// ../internal/src/__fragments/common/client-side-analytics.ts
import { gql as gql21 } from "@apollo/client";
var clientSideAnalyticsFragment = gql21(_templateObject20());
// ../internal/src/__fragments/common/car-rental-location.ts
import { gql as gql22 } from "@apollo/client";
var __CarRentalLocation = gql22(_templateObject21());
// ../internal/src/__fragments/common/date-time.ts
import { gql as gql23 } from "@apollo/client";
var __DateTime = gql23(_templateObject22());
// ../internal/src/components/activity-trip-save-item/activity-trips-save-item.tsx
var __Fragment4 = gql24(_templateObject23(), __DateTime, __CarRentalLocation, __DateFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var ActivitySaveItem = function (param) {
  var data = param.data,
    heartLayoutPosition = param.heartLayoutPosition;
  var _data_attributes;
  switch ((_data_attributes = data.attributes) === null || _data_attributes === void 0 ? void 0 : _data_attributes.__typename) {
    case "TripsSaveActivityAttributes":
      {
        return /* @__PURE__ */React20.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */React20.createElement(TripSaveItem, {
          data: data,
          source: Source.ACTIVITY_DETAILS,
          heartLayoutPosition: heartLayoutPosition
        }));
      }
    default:
      return null;
  }
};
ActivitySaveItem.displayName = "ActivitySaveItem";
ActivitySaveItem.fragment = __Fragment4;
// ../internal/src/components/activity-card/__private/activity-click-action.tsx
import React21 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSButton } from "@egds/react-core/button";
import { EGDSImageLink } from "@egds/react-core/images";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var __Fragment5 = gql25(_templateObject24());
var ActivityClickAction = function (param) {
  var data = param.data;
  var clickTracker = useClickTracker4();
  switch (data.__typename) {
    case "ActivityLinkClickAction":
      {
        var _data_analytics, _data_analytics1;
        var handleClick = function () {
          if (data.linkTagUrl) {
            var target = data.opensInNewTab ? "_blank" : "_self";
            window.open(data.linkTagUrl, target);
          }
        };
        var _data_analytics_referrerId;
        return /* @__PURE__ */React21.createElement(EGDSImageLink, null, /* @__PURE__ */React21.createElement(EGDSButton, {
          analytics: {
            id: (_data_analytics_referrerId = (_data_analytics = data.analytics) === null || _data_analytics === void 0 ? void 0 : _data_analytics.referrerId) !== null && _data_analytics_referrerId !== void 0 ? _data_analytics_referrerId : "",
            description: (_data_analytics1 = data.analytics) === null || _data_analytics1 === void 0 ? void 0 : _data_analytics1.linkName,
            callback: function (id, desc) {
              return clickTracker(id, desc);
            }
          },
          onClick: handleClick,
          type: "button"
        }, data.accessibilityText));
      }
    default:
      return null;
  }
};
ActivityClickAction.displayName = "ActivityClickAction";
ActivityClickAction.fragment = __Fragment5;
// ../internal/src/components/activity-card/activity-card-content/activity-card-text-content.tsx
import React25 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
// ../internal/src/components/egds-expando/egds-expando-peek.tsx
import React22 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql26(_templateObject25());
var ActivitiesEGDSExpandoPeek = function (param) {
  var lines = param.lines,
    items = param.items,
    className = param.className,
    data = param.data,
    children = param.children;
  var expanded = data.expanded,
    expandAnalytics = data.expandAnalytics,
    expandedLabel = data.expandedLabel,
    collapseAnalytics = data.collapseAnalytics,
    collapsedLabel = data.collapsedLabel,
    expandedAccessibilityText = data.expandedAccessibilityText,
    collapsedAccessibilityText = data.collapsedAccessibilityText;
  var clickTracker = useClickTracker5();
  var _React22_useState = _sliced_to_array(React22.useState(expanded), 2),
    isVisible = _React22_useState[0],
    setIsVisible = _React22_useState[1];
  var _expandAnalytics_referrerId, _expandAnalytics_linkName;
  var expandoExpandAnalytics = {
    id: (_expandAnalytics_referrerId = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId) !== null && _expandAnalytics_referrerId !== void 0 ? _expandAnalytics_referrerId : "",
    description: (_expandAnalytics_linkName = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName) !== null && _expandAnalytics_linkName !== void 0 ? _expandAnalytics_linkName : "",
    callback: React22.useCallback(function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  var _collapseAnalytics_referrerId, _collapseAnalytics_linkName;
  var expandoCollapseAnalytics = {
    id: (_collapseAnalytics_referrerId = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId) !== null && _collapseAnalytics_referrerId !== void 0 ? _collapseAnalytics_referrerId : "",
    description: (_collapseAnalytics_linkName = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName) !== null && _collapseAnalytics_linkName !== void 0 ? _collapseAnalytics_linkName : "",
    callback: React22.useCallback(function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  var handleClick = React22.useCallback(function () {
    setIsVisible(!isVisible);
  }, [isVisible]);
  return /* @__PURE__ */React22.createElement(EGDSExpandoPeek, {
    expandLabel: collapsedLabel,
    collapseLabel: expandedLabel,
    analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics,
    className: className,
    lines: lines,
    items: items,
    isVisible: isVisible,
    handleClick: handleClick,
    expandA11yLabel: collapsedAccessibilityText !== null && collapsedAccessibilityText !== void 0 ? collapsedAccessibilityText : collapsedLabel,
    collapseA11yLabel: expandedAccessibilityText !== null && expandedAccessibilityText !== void 0 ? expandedAccessibilityText : expandedLabel
  }, children);
};
ActivitiesEGDSExpandoPeek.fragment = fragment12;
ActivitiesEGDSExpandoPeek.displayName = "ActivitiesEGDSExpandoPeek";
// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React23 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSExpandoListItem } from "@egds/react-core/expando";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var fragment13 = gql27(_templateObject26());
var ActivitiesEGDSExpandoListItem = function (param) {
  var children = param.children,
    className = param.className,
    data = param.data,
    titleSize = param.titleSize,
    titleTag = param.titleTag,
    isIndented = param.isIndented;
  var expandAnalytics = data.expandAnalytics,
    expandedLabel = data.expandedLabel,
    collapseAnalytics = data.collapseAnalytics,
    collapsedLabel = data.collapsedLabel,
    expanded = data.expanded;
  var clickTracker = useClickTracker6();
  var _React23_useState = _sliced_to_array(React23.useState(expanded), 2),
    isVisible = _React23_useState[0],
    setIsVisible = _React23_useState[1];
  var _React23_useState1 = _sliced_to_array(React23.useState(expanded ? expandedLabel : collapsedLabel), 2),
    label = _React23_useState1[0],
    setLabel = _React23_useState1[1];
  var analytics;
  if (collapseAnalytics && expandAnalytics) {
    analytics = {
      id: isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId,
      description: isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName,
      callback: function (referrerId, linkName) {
        clickTracker(referrerId, linkName);
      }
    };
  }
  var onToggle = React23.useCallback(function () {
    if (isVisible) {
      setLabel(collapsedLabel);
    } else {
      setLabel(expandedLabel);
    }
    setIsVisible(!isVisible);
  }, [isVisible, collapsedLabel, expandedLabel]);
  return /* @__PURE__ */React23.createElement(EGDSExpandoListItem, {
    analytics: analytics,
    className: className,
    isVisible: isVisible,
    expandoTitle: /* @__PURE__ */React23.createElement(EGDSHeading2, {
      tag: titleTag,
      size: titleSize
    }, label),
    expandoDescription: children,
    onToggle: onToggle,
    isIndented: isIndented
  });
};
ActivitiesEGDSExpandoListItem.fragment = fragment13;
ActivitiesEGDSExpandoListItem.displayName = "ActivitiesEGDSExpandoListItem";
// ../internal/src/components/egds-expando/egds-expando.tsx
import React24 from "react";
import { gql as gql28 } from "@apollo/client";
var fragment14 = gql28(_templateObject27(), ActivitiesEGDSExpandoPeek.fragment, ActivitiesEGDSExpandoListItem.fragment);
var ActivitiesEGDSExpando = function (param) {
  var className = param.className,
    expandoListItemTitleSize = param.expandoListItemTitleSize,
    expandoListItemTitleTag = param.expandoListItemTitleTag,
    expandoListItemIsIndented = param.expandoListItemIsIndented,
    expandoPeekLines = param.expandoPeekLines,
    expandoPeekItems = param.expandoPeekItems,
    data = param.data,
    children = param.children;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSExpandoPeek":
      return /* @__PURE__ */React24.createElement(ActivitiesEGDSExpandoPeek, {
        className: className,
        data: data,
        lines: expandoPeekLines,
        items: expandoPeekItems
      }, children);
    case "EGDSExpandoListItem":
      return /* @__PURE__ */React24.createElement(ActivitiesEGDSExpandoListItem, {
        className: className,
        data: data,
        titleSize: expandoListItemTitleSize,
        titleTag: expandoListItemTitleTag,
        isIndented: expandoListItemIsIndented
      }, children);
    default:
      return null;
  }
};
ActivitiesEGDSExpando.fragment = fragment14;
ActivitiesEGDSExpando.displayName = "ActivitiesEGDSExpando";
// ../internal/src/components/activity-card/activity-card-content/activity-card-text-content.tsx
var __Fragment6 = gql29(_templateObject28(), ActivitiesEGDSExpando.fragment, ActivitiesEGDSText.fragment);
var topMargin = {
  blockstart: "two"
};
var ActivityCardTextContent = function (param) {
  var className = param.className,
    headingSize = param.headingSize,
    textSize = param.textSize,
    data = param.data;
  var heading = data.heading,
    items = data.items,
    expando = data.expando;
  return items.length ? /* @__PURE__ */React25.createElement("div", {
    className: className
  }, heading && /* @__PURE__ */React25.createElement(ActivitiesEGDSText, {
    headingSize: headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    margin: topMargin
  }, /* @__PURE__ */React25.createElement(ActivitiesEGDSExpando, {
    expandoPeekLines: 4,
    data: expando
  }, items.map(function (item, index) {
    return /* @__PURE__ */React25.createElement(ActivitiesEGDSText, {
      key: "activity-card-text-content-item-".concat(index),
      textSize: textSize,
      data: item
    });
  }))) : items.map(function (item, index) {
    return /* @__PURE__ */React25.createElement(EGDSSpacing4, {
      key: "activity-card-text-content-item-".concat(index),
      margin: topMargin
    }, /* @__PURE__ */React25.createElement(ActivitiesEGDSText, {
      textSize: textSize,
      data: item
    }));
  })) : null;
};
ActivityCardTextContent.displayName = "ActivityCardTextContent";
ActivityCardTextContent.fragment = __Fragment6;
// ../internal/src/components/activity-card/activity-card-content/activity-card-heading-content.tsx
import React26 from "react";
import { gql as gql30 } from "@apollo/client";
var __Fragment7 = gql30(_templateObject29(), ActivitiesEGDSText.fragment);
var ActivityCardHeadingContent = function (param) {
  var className = param.className,
    headingSize = param.headingSize,
    data = param.data;
  var heading = data.heading;
  return heading && /* @__PURE__ */React26.createElement(ActivitiesEGDSText, {
    className: className,
    headingSize: headingSize,
    data: heading
  });
};
ActivityCardHeadingContent.displayName = "ActivityCardHeadingContent";
ActivityCardHeadingContent.fragment = __Fragment7;
// ../internal/src/components/activity-card/activity-card-content/activity-card-text-list-content.tsx
import React38 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
// ../internal/src/components/egds-list/egds-text-list.tsx
import React36 from "react";
import { gql as gql40 } from "@apollo/client";
// ../internal/src/components/egds-list/egds-bulleted-list.tsx
import React33 from "react";
import { gql as gql37 } from "@apollo/client";
import { withEGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList2 } from "@egds/react-core/list";
var _obj8;
// ../internal/src/components/egds-list/__private/text-list-size.ts
var textListSizeMapper = (_obj8 = {}, _define_property(_obj8, "LIST_1" /* LIST_1 */, 1), _define_property(_obj8, "LIST_2" /* LIST_2 */, 2), _define_property(_obj8, "LIST_3" /* LIST_3 */, 3), _obj8);
// ../internal/src/components/egds-list/egds-text-list-item.tsx
import React32 from "react";
import { gql as gql36 } from "@apollo/client";
// ../internal/src/components/egds-list/earn-message-container-list-item.tsx
import React27 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSListItem } from "@egds/react-core/list";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
var fragment15 = gql31(_templateObject30(), EGDSGraphic.fragment, EGDSSpannableText.fragment);
var EarnMessageContainerListItem = function (param) {
  var className = param.className,
    textSize = param.textSize,
    inline = param.inline,
    data = param.data;
  var themeProps = data.style ? EGDSTextThemeMapper[data.style] : void 0;
  return /* @__PURE__ */React27.createElement(EGDSListItem, null, /* @__PURE__ */React27.createElement(EGDSGraphic, {
    data: data.graphic
  }), /* @__PURE__ */React27.createElement("div", {
    "data-stid": "loyalty-earn-message"
  }, data.stylizedText && /* @__PURE__ */React27.createElement(ActivitiesEGDSText, {
    className: className,
    data: data.stylizedText,
    textSize: textSize,
    theme: themeProps,
    inline: inline
  }), !data.stylizedText && /* @__PURE__ */React27.createElement(EGDSText7, {
    className: className,
    size: textSize,
    theme: themeProps
  }, "$", data.text)));
};
EarnMessageContainerListItem.fragment = fragment15;
EarnMessageContainerListItem.displayName = "EarnMessageContainerListItem";
// ../internal/src/components/egds-list/egds-text-icon-link-list-item.tsx
import React28 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
var fragment16 = gql32(_templateObject31(), ActivitiesEGDSIcon.fragment);
var EGDSTextIconLinkListItem = function (param) {
  var data = param.data;
  var text = data.text,
    icon = data.icon,
    _data_action = data.action,
    accessibility = _data_action.accessibility,
    analytics = _data_action.analytics,
    resource = _data_action.resource,
    target = _data_action.target;
  var clickTracker = useClickTracker7();
  var onClick = React28.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React28.createElement(EGDSListItem2, null, /* @__PURE__ */React28.createElement(ActivitiesEGDSIcon, {
    data: icon
  }), /* @__PURE__ */React28.createElement(EGDSLink3, {
    onClickCapture: onClick
  }, /* @__PURE__ */React28.createElement("a", {
    target: UILinkTargetMap[target],
    href: resource.value
  }, text, accessibility && /* @__PURE__ */React28.createElement(EGDSText8, {
    className: "is-visually-hidden"
  }, accessibility))));
};
EGDSTextIconLinkListItem.fragment = fragment16;
EGDSTextIconLinkListItem.displayName = "EGDSTextIconLinkListItem";
// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
import React30 from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSList, EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
import React29 from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
var fragment17 = gql33(_templateObject32());
var EGDSTextStandardListItem = function (param) {
  var data = param.data;
  var text = data.text;
  return /* @__PURE__ */React29.createElement(EGDSListItem3, null, text);
};
EGDSTextStandardListItem.fragment = fragment17;
EGDSTextStandardListItem.displayName = "EGDSTextStandardListItem";
// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
var fragment18 = gql34(_templateObject33(), ActivitiesEGDSIcon.fragment);
var EGDSTextIconListItem = function (param) {
  var data = param.data,
    nestedListBullet = param.nestedListBullet;
  var text = data.text,
    icon = data.icon,
    nestedList = data.nestedList;
  return /* @__PURE__ */React30.createElement(EGDSListItem4, null, /* @__PURE__ */React30.createElement(ActivitiesEGDSIcon, {
    data: icon
  }), text, nestedList && /* @__PURE__ */React30.createElement(EGDSList, {
    spacing: !!text,
    bullet: nestedListBullet
  }, nestedList.listItems.map(function (listItem, index) {
    if (listItem.__typename === "EGDSTextStandardListItem") {
      return /* @__PURE__ */React30.createElement(EGDSTextStandardListItem, {
        data: listItem,
        key: "egds-text-standard-list-item-".concat(index)
      });
    }
    return null;
  })));
};
EGDSTextIconListItem.fragment = fragment18;
EGDSTextIconListItem.displayName = "EGDSTextIconListItem";
// ../internal/src/components/egds-list/egds-text-with-mark-list-item.tsx
import React31 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSListItem as EGDSListItem5 } from "@egds/react-core/list";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
var fragment19 = gql35(_templateObject34(), ActivitiesEGDSMark.fragment);
var EGDSTextWithMarkListItem = function (param) {
  var data = param.data;
  var text = data.text,
    mark = data.mark,
    style = data.style;
  var themeProps = style ? textThemeMapper[style] : void 0;
  return /* @__PURE__ */React31.createElement(EGDSListItem5, null, mark && /* @__PURE__ */React31.createElement(ActivitiesEGDSMark, {
    data: mark
  }), /* @__PURE__ */React31.createElement(EGDSText9, {
    theme: themeProps
  }, /* @__PURE__ */React31.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};
EGDSTextWithMarkListItem.fragment = fragment19;
EGDSTextWithMarkListItem.displayName = "EGDSTextWithMarkListItem";
// ../internal/src/components/egds-list/egds-text-list-item.tsx
var fragment20 = gql36(_templateObject35(), EGDSTextStandardListItem.fragment, EGDSTextIconListItem.fragment, EGDSTextIconLinkListItem.fragment, EGDSTextWithMarkListItem.fragment, EarnMessageContainerListItem.fragment);
var EGDSTextListItem = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSTextStandardListItem":
      return /* @__PURE__ */React32.createElement(EGDSTextStandardListItem, {
        data: data
      });
    case "EGDSTextIconListItem":
      return /* @__PURE__ */React32.createElement(EGDSTextIconListItem, {
        data: data
      });
    case "EGDSTextIconLinkListItem":
      return /* @__PURE__ */React32.createElement(EGDSTextIconLinkListItem, {
        data: data
      });
    case "EGDSTextWithMarkListItem":
      return /* @__PURE__ */React32.createElement(EGDSTextWithMarkListItem, {
        data: data
      });
    case "EarnMessageContainerListItem":
      return /* @__PURE__ */React32.createElement(EarnMessageContainerListItem, {
        data: data
      });
    default:
      return null;
  }
};
EGDSTextListItem.fragment = fragment20;
EGDSTextListItem.displayName = "EGDSTextListItem";
// ../internal/src/components/egds-list/egds-bulleted-list.tsx
var fragment21 = gql37(_templateObject36(), EGDSTextListItem.fragment);
var EGDSBulletedList = function (param) {
  var className = param.className,
    columns = param.columns,
    expando = param.expando,
    data = param.data;
  var listItems = data.listItems,
    size = data.size;
  if (!listItems.length) {
    return null;
  }
  var sizeProps = size ? textListSizeMapper[size] : void 0;
  var List = function (props) {
    return /* @__PURE__ */React33.createElement(EGDSList2, _object_spread({
      spacing: false,
      size: sizeProps,
      type: "unordered"
    }, props), listItems.map(function (item, index) {
      return /* @__PURE__ */React33.createElement(EGDSTextListItem, {
        key: index,
        data: item
      });
    }));
  };
  var ListWithGrid = withEGDSLayoutGrid(List);
  return expando ? /* @__PURE__ */React33.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className: className,
    data: expando
  }, /* @__PURE__ */React33.createElement(EGDSList2, {
    spacing: false,
    size: sizeProps,
    type: "unordered"
  }, listItems.map(function (item, index) {
    return /* @__PURE__ */React33.createElement(EGDSTextListItem, {
      key: index,
      data: item
    });
  }))) : /* @__PURE__ */React33.createElement(ListWithGrid, {
    className: className,
    columns: columns
  });
};
EGDSBulletedList.fragment = fragment21;
EGDSBulletedList.displayName = "EGDSBulletedList";
// ../internal/src/components/egds-list/egds-text-icon-list.tsx
import React34 from "react";
import { gql as gql38 } from "@apollo/client";
import { withEGDSLayoutGrid as withEGDSLayoutGrid2 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList3 } from "@egds/react-core/list";
var fragment22 = gql38(_templateObject37(), EGDSTextIconListItem.fragment);
var EGDSTextIconList = function (param) {
  var className = param.className,
    bullet = param.bullet,
    nestedListBullet = param.nestedListBullet,
    columns = param.columns,
    expando = param.expando,
    data = param.data;
  var listItems = data.listItems,
    size = data.size;
  if (!listItems.length) {
    return null;
  }
  var listBulletProp = bullet === "icon-standard" || bullet === "icon-alternate" ? bullet : "icon-standard";
  var sizeProps = size ? textListSizeMapper[size] : void 0;
  var List = function (props) {
    return /* @__PURE__ */React34.createElement(EGDSList3, _object_spread({
      spacing: false,
      bullet: listBulletProp,
      size: sizeProps,
      type: "unordered"
    }, props), listItems.map(function (item, index) {
      return /* @__PURE__ */React34.createElement(EGDSTextIconListItem, {
        key: "egds-text-icon-list-item-".concat(index),
        nestedListBullet: nestedListBullet,
        data: item
      });
    }));
  };
  var ListWithGrid = withEGDSLayoutGrid2(List);
  return expando ? /* @__PURE__ */React34.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className: className,
    data: expando
  }, /* @__PURE__ */React34.createElement(EGDSList3, {
    spacing: false,
    bullet: listBulletProp,
    size: sizeProps,
    type: "unordered"
  }, listItems.map(function (item, index) {
    return /* @__PURE__ */React34.createElement(EGDSTextIconListItem, {
      key: "egds-text-icon-list-item-".concat(index),
      nestedListBullet: nestedListBullet,
      data: item
    });
  }))) : /* @__PURE__ */React34.createElement(ListWithGrid, {
    className: className,
    columns: columns
  });
};
EGDSTextIconList.fragment = fragment22;
EGDSTextIconList.displayName = "EGDSTextIconList";
// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React35 from "react";
import { gql as gql39 } from "@apollo/client";
import { withEGDSLayoutGrid as withEGDSLayoutGrid3 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList4 } from "@egds/react-core/list";
var fragment23 = gql39(_templateObject38(), EGDSTextListItem.fragment);
var EGDSUnorderedList = function (param) {
  var className = param.className,
    bullet = param.bullet,
    columns = param.columns,
    expando = param.expando,
    data = param.data;
  var listItems = data.listItems,
    size = data.size;
  if (!listItems.length) {
    return null;
  }
  var sizeProps = size ? textListSizeMapper[size] : void 0;
  var List = function (props) {
    return /* @__PURE__ */React35.createElement(EGDSList4, _object_spread({
      spacing: false,
      bullet: bullet,
      size: sizeProps,
      type: "unordered"
    }, props), listItems.map(function (item, index) {
      return /* @__PURE__ */React35.createElement(EGDSTextListItem, {
        key: index,
        data: item
      });
    }));
  };
  var ListWithGrid = withEGDSLayoutGrid3(List);
  return expando ? /* @__PURE__ */React35.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className: className,
    data: expando
  }, /* @__PURE__ */React35.createElement(EGDSList4, {
    spacing: false,
    bullet: bullet,
    size: sizeProps,
    type: "unordered"
  }, listItems.map(function (item, index) {
    return /* @__PURE__ */React35.createElement(EGDSTextListItem, {
      key: index,
      data: item
    });
  }))) : /* @__PURE__ */React35.createElement(ListWithGrid, {
    className: className,
    columns: columns
  });
};
EGDSUnorderedList.fragment = fragment23;
EGDSUnorderedList.displayName = "EGDSUnorderedList";
// ../internal/src/components/egds-list/egds-text-list.tsx
var fragment24 = gql40(_templateObject39(), EGDSUnorderedList.fragment, EGDSBulletedList.fragment, EGDSTextIconList.fragment);
var EGDSTextList = function (param) {
  var className = param.className,
    bullet = param.bullet,
    columns = param.columns,
    expando = param.expando,
    nestedListBullet = param.nestedListBullet,
    data = param.data;
  switch (data.__typename) {
    case "EGDSUnorderedList":
      return /* @__PURE__ */React36.createElement(EGDSUnorderedList, {
        className: className,
        bullet: bullet,
        columns: columns,
        data: data,
        expando: expando
      });
    case "EGDSBulletedList":
      return /* @__PURE__ */React36.createElement(EGDSBulletedList, {
        className: className,
        columns: columns,
        data: data,
        expando: expando
      });
    case "EGDSTextIconList":
      return /* @__PURE__ */React36.createElement(EGDSTextIconList, {
        className: className,
        bullet: bullet,
        columns: columns,
        nestedListBullet: nestedListBullet,
        data: data,
        expando: expando
      });
    default:
      return null;
  }
};
EGDSTextList.fragment = fragment24;
EGDSTextList.displayName = "EGDSTextList";
// ../internal/src/components/egds-list/egds-link-list.tsx
import React37 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSList as EGDSList5, EGDSListItem as EGDSListItem6 } from "@egds/react-core/list";
var fragment25 = gql41(_templateObject40(), EGDSStandardLink.fragment);
var EGDSLinkList = function (param) {
  var className = param.className,
    orientation = param.orientation,
    data = param.data;
  var listItems = data.listItems;
  return /* @__PURE__ */React37.createElement(EGDSList5, {
    spacing: false,
    className: className,
    bullet: "no-bullet",
    orientation: orientation
  }, listItems.map(function (item, index) {
    return /* @__PURE__ */React37.createElement(EGDSListItem6, {
      key: "egds-link-list-".concat(index)
    }, /* @__PURE__ */React37.createElement(EGDSStandardLink, {
      key: index,
      data: item
    }));
  }));
};
EGDSLinkList.fragment = fragment25;
EGDSLinkList.displayName = "EGDSLinkList";
// ../internal/src/components/activity-card/activity-card-content/activity-card-text-list-content.tsx
var __Fragment8 = gql42(_templateObject41(), ActivitiesEGDSExpando.fragment, EGDSGraphic.fragment, EGDSTextList.fragment, ActivitiesEGDSText.fragment);
var topMargin2 = {
  blockstart: "two"
};
var ActivityCardTextListContent = function (param) {
  var className = param.className,
    bullet = param.bullet,
    nestedListBullet = param.nestedListBullet,
    headingSize = param.headingSize,
    columns = param.columns,
    data = param.data;
  var heading = data.heading,
    list = data.list,
    icon = data.icon,
    expando = data.expando;
  return /* @__PURE__ */React38.createElement("div", {
    className: className
  }, /* @__PURE__ */React38.createElement(EGDSLayoutFlex3, {
    space: "three"
  }, icon && /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React38.createElement(EGDSGraphic, {
    data: icon
  })), /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React38.createElement("div", null, heading && /* @__PURE__ */React38.createElement(ActivitiesEGDSText, {
    headingSize: headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React38.createElement(EGDSSpacing5, {
    margin: topMargin2
  }, /* @__PURE__ */React38.createElement(EGDSTextList, {
    bullet: bullet,
    columns: columns,
    nestedListBullet: nestedListBullet,
    expando: expando,
    data: list
  })) : /* @__PURE__ */React38.createElement(EGDSSpacing5, {
    margin: topMargin2
  }, /* @__PURE__ */React38.createElement(EGDSTextList, {
    bullet: bullet,
    columns: columns,
    nestedListBullet: nestedListBullet,
    data: list
  }))))));
};
ActivityCardTextListContent.displayName = "ActivityCardTextListContent";
ActivityCardTextListContent.fragment = __Fragment8;
// ../internal/src/components/activity-card/activity-card-content/activity-card-link-list-content.tsx
import React39 from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
var __Fragment9 = gql43(_templateObject42(), EGDSLinkList.fragment, ActivitiesEGDSHeading.fragment);
var linkListMargin = {
  blockstart: "one"
};
var ActivityCardLinkListContent = function (param) {
  var className = param.className,
    headingSize = param.headingSize,
    orientation = param.orientation,
    data = param.data;
  var heading = data.heading,
    list = data.list;
  return /* @__PURE__ */React39.createElement("div", {
    className: className
  }, heading && /* @__PURE__ */React39.createElement(ActivitiesEGDSHeading, {
    size: headingSize,
    data: heading
  }), /* @__PURE__ */React39.createElement(EGDSSpacing6, {
    margin: linkListMargin
  }, /* @__PURE__ */React39.createElement(EGDSLinkList, {
    data: list,
    orientation: orientation
  })));
};
ActivityCardLinkListContent.displayName = "ActivityCardLinkListContent";
ActivityCardLinkListContent.fragment = __Fragment9;
// ../internal/src/components/activity-card/activity-card-content/activity-card-section-content.tsx
import React66 from "react";
import { gql as gql74 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign3 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
// ../internal/src/components/activity-card/activity-card-content/activity-card-reviews-rating-content.tsx
import React65 from "react";
import { gql as gql73 } from "@apollo/client";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
import React45 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSDatePicker, EGDSDatePickerRenderType, EGDSDatePickerTriggeredSelector } from "@egds/react-core/date-picker";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-toolbar.tsx
import React40 from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
var __Fragment10 = gql44(_templateObject43());
var EGDSDialogToolbar = function (param) {
  var data = param.data,
    toolbarType = param.toolbarType,
    toolbarAction = param.toolbarAction;
  var _data_closeText;
  return /* @__PURE__ */React40.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: toolbarAction,
      navType: toolbarType,
      navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
    },
    toolbarTitle: data.title
  });
};
EGDSDialogToolbar.fragment = __Fragment10;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/activity-dialog/__private/__fragments/egds-travelers-step-input.tsx
import React41 from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSStepInput } from "@egds/react-core/step-input";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
var __Fragment11 = gql45(_templateObject44());
var EGDSTravelersStepInput = function (param) {
  var data = param.data,
    onChange = param.onChange,
    countIndex = param.countIndex;
  var decreaseText = data.decreaseText,
    increaseText = data.increaseText,
    label = data.label,
    max = data.max,
    min = data.min,
    step = data.step,
    subLabel = data.subLabel,
    value = data.value,
    key = data.key;
  var _React41_useState = _sliced_to_array(React41.useState(value), 2),
    countValue = _React41_useState[0],
    setCountValue = _React41_useState[1];
  var clickTracker = useClickTracker8();
  var handleChange = function (event) {
    var stepValue = parseInt(event.target.value, 10);
    onChange(stepValue, key, countIndex);
    if (data.__typename === "EGDSTravelerStepInput") {
      if (stepValue > countValue) {
        clickTracker(data.increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
      } else {
        clickTracker(data.decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
      }
    }
    setCountValue(stepValue);
  };
  var travelerId = React41.useMemo(function () {
    return Math.random().toString();
  }, []);
  return /* @__PURE__ */React41.createElement(EGDSStepInput, {
    label: label,
    incrementText: increaseText !== null && increaseText !== void 0 ? increaseText : "",
    decrementText: decreaseText !== null && decreaseText !== void 0 ? decreaseText : "",
    incrementId: "".concat(travelerId, "-increase"),
    decrementId: "".concat(travelerId, "-decrease"),
    min: min !== null && min !== void 0 ? min : 0,
    max: max !== null && max !== void 0 ? max : 0,
    step: step,
    onChange: handleChange,
    value: countValue,
    description: subLabel !== null && subLabel !== void 0 ? subLabel : "",
    id: travelerId
  });
};
EGDSTravelersStepInput.displayName = "EGDSTravelersStepInput";
EGDSTravelersStepInput.fragment = __Fragment11;
// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
import React42 from "react";
import { gql as gql47 } from "@apollo/client";
import { EGDSDialogFooter as EGDSDialogFooter2 } from "@egds/react-core/dialog";
// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer-button.ts
import { gql as gql46 } from "@apollo/client";
var __EGDSDialogFooterButtonFragment = gql46(_templateObject45());
var getButton = function (data, closeDialog) {
  switch (data.__typename) {
    case "UITertiaryButton":
      {
        var _data_primary;
        return {
          text: (_data_primary = data.primary) !== null && _data_primary !== void 0 ? _data_primary : "",
          type: "tertiary",
          onClick: closeDialog
        };
      }
    case "UIPrimaryButton":
      var _data_primary1;
      return {
        text: (_data_primary1 = data.primary) !== null && _data_primary1 !== void 0 ? _data_primary1 : "",
        type: "primary",
        onClick: closeDialog
      };
    default:
      var _data_primary2;
      return {
        text: (_data_primary2 = data.primary) !== null && _data_primary2 !== void 0 ? _data_primary2 : "",
        type: "primary",
        onClick: closeDialog
      };
  }
};
// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
var __EGDSDialogFooterFragment = gql47(_templateObject46(), __EGDSDialogFooterButtonFragment);
var ActivitiesEGDSDialogFooter = function (param) {
  var data = param.data,
    dialogActionMap = param.dialogActionMap,
    closeDialog = param.closeDialog;
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      {
        var buttons = data.buttons;
        var buttonMap = buttons.map(function (button, index) {
          if (dialogActionMap && dialogActionMap.length > 1) {
            return _object_spread({}, getButton(button, closeDialog), dialogActionMap[index]);
          }
          return _object_spread({}, getButton(button, closeDialog));
        });
        var _buttonMap_, _buttonMap_1, _buttonMap_2;
        return /* @__PURE__ */React42.createElement(EGDSDialogFooter2, {
          buttonOne: (_buttonMap_ = buttonMap[0]) !== null && _buttonMap_ !== void 0 ? _buttonMap_ : void 0,
          buttonTwo: (_buttonMap_1 = buttonMap[1]) !== null && _buttonMap_1 !== void 0 ? _buttonMap_1 : void 0,
          buttonThree: (_buttonMap_2 = buttonMap[2]) !== null && _buttonMap_2 !== void 0 ? _buttonMap_2 : void 0
        });
      }
    default:
      return null;
  }
};
ActivitiesEGDSDialogFooter.displayName = "ActivitiesEGDSDialogFooter";
ActivitiesEGDSDialogFooter.fragment = __EGDSDialogFooterFragment;
// ../internal/src/components/activity-dialog/__private/__fragments/egds-date-picker-content.ts
import { gql as gql48 } from "@apollo/client";
var __EGDSDatePickerContentFragment = gql48(_templateObject47());
var getDatePickerContent = function (data) {
  var accessibility = data.accessibility,
    dateKey = data.dateKey,
    text = data.text,
    theme = data.theme;
  return _define_property({}, dateKey, {
    text: text !== null && text !== void 0 ? text : "",
    ariaLabel: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: theme !== null && theme !== void 0 ? theme : void 0
  });
};
// ../internal/src/components/activity-dialog/__private/activity-date-range-picker-dialog-helper.ts
import { DayName } from "@egds/react-core/date-picker";
var convertFromMiliSecondsToDays = function (miliseconds) {
  return Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
};
var convertToDateObject = function (param) {
  var year = param.year,
    month = param.month,
    day = param.day;
  return new Date(year, month - 1, day);
};
var _obj9;
var EGDSDayNameMap = (_obj9 = {}, _define_property(_obj9, "SUN" /* SUN */, DayName.SUN), _define_property(_obj9, "MON" /* MON */, DayName.MON), _define_property(_obj9, "TUE" /* TUE */, DayName.TUE), _define_property(_obj9, "WED" /* WED */, DayName.WED), _define_property(_obj9, "THU" /* THU */, DayName.THU), _define_property(_obj9, "FRI" /* FRI */, DayName.FRI), _define_property(_obj9, "SAT" /* SAT */, DayName.SAT), _obj9);
// ../internal/src/components/activity-dialog/activity-dialog-trigger.tsx
import React44 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSFakeInput } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React43 from "react";
import { gql as gql50 } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-button/egds-button-action.ts
import { gql as gql49 } from "@apollo/client";
var __EGDSButtonActionFragment = gql49(_templateObject48(), ActivitiesEGDSHeading.fragment, EGDSPlainText.fragment);
// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql50(_templateObject49(), __EGDSButtonActionFragment);
var ActivitiesEGDSButton = function (param) {
  var analytics = param.analytics,
    className = param.className,
    domRef = param.domRef,
    href = param.href,
    isFullWidth = param.isFullWidth,
    onClickHandler = param.onClickHandler,
    size = param.size,
    data = param.data;
  var __typename = data.__typename,
    accessibility = data.accessibility,
    action = data.action,
    primary = data.primary,
    disabled = data.disabled,
    icon = data.icon;
  var clickTracker = useClickTracker9();
  var analyticsButton = action ? {
    description: action.analytics.linkName,
    id: action.analytics.referrerId,
    callback: function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }
  } : void 0;
  var handleOnClick = React43.useCallback(function () {
    onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
  }, [onClickHandler]);
  if (!primary) {
    return null;
  }
  var buttonProps = {
    analytics: analytics || analyticsButton,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    disabled: disabled,
    href: href,
    isFullWidth: isFullWidth,
    onClick: handleOnClick,
    size: size,
    domRef: domRef
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React43.createElement(EGDSPrimaryButton, _object_spread({}, buttonProps), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React43.createElement(EGDSSecondaryButton, _object_spread({}, buttonProps), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React43.createElement(EGDSTertiaryButton, _object_spread({}, buttonProps), primary);
    case "EGDSOverlayButton":
      var _icon_id;
      return /* @__PURE__ */React43.createElement(EGDSOverlayButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */React43.createElement(EGDSIcon2, {
        name: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : ""
      }), primary);
    default:
      return null;
  }
};
ActivitiesEGDSButton.fragment = _Fragment;
ActivitiesEGDSButton.displayName = "ActivitiesEGDSButton";
// ../internal/src/components/activity-dialog/activity-dialog-trigger.tsx
var __Fragment12 = gql51(_templateObject50(), EGDSGraphic.fragment, ActivitiesEGDSButton.fragment);
var ActivityDialogTrigger = function (param) {
  var className = param.className,
    data = param.data,
    domRef = param.domRef,
    _param_linkIconPosition = param.linkIconPosition,
    linkIconPosition = _param_linkIconPosition === void 0 ? "TRAILING" /* TRAILING */ : _param_linkIconPosition,
    openDialog = param.openDialog,
    autoFocus = param.autoFocus;
  var accessibility = data.accessibility,
    analytics = data.analytics;
  var clickTracker = useClickTracker10();
  var analyticsDialogTrigger = {
    description: analytics.linkName,
    id: analytics.referrerId,
    callback: React44.useCallback(function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  var trackAnalytics = React44.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [analytics, clickTracker]);
  switch (data.__typename) {
    case "ActivityButtonDialogTrigger":
      return /* @__PURE__ */React44.createElement(ActivitiesEGDSButton, {
        analytics: analyticsDialogTrigger,
        size: EGDSButtonSize.MEDIUM,
        onClickHandler: openDialog,
        domRef: domRef,
        data: data.button
      });
    case "ActivityGraphicDialogTrigger":
      return /* @__PURE__ */React44.createElement(EGDSMoreInfoTrigger, {
        className: className,
        analytics: analyticsDialogTrigger,
        onClick: openDialog,
        size: "small"
      }, /* @__PURE__ */React44.createElement("button", {
        ref: domRef,
        type: "button"
      }, /* @__PURE__ */React44.createElement(EGDSGraphic, {
        data: data.graphic
      }), /* @__PURE__ */React44.createElement("span", {
        className: "is-visually-hidden"
      }, accessibility)));
    case "ActivityFakeInputDialogTrigger":
      var _data_icon;
      var _data_value;
      return /* @__PURE__ */React44.createElement("div", {
        className: className
      }, /* @__PURE__ */React44.createElement(EGDSFakeInput, {
        domRef: domRef,
        label: data.label,
        value: (_data_value = data.value) !== null && _data_value !== void 0 ? _data_value : "",
        icon: (_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.id,
        onChange: openDialog,
        onClick: openDialog,
        analytics: analyticsDialogTrigger,
        autoFocus: autoFocus
      }));
    case "ActivityLinkDialogTrigger":
      return /* @__PURE__ */React44.createElement(EGDSLink4, {
        className: className,
        onClick: openDialog,
        onClickCapture: trackAnalytics,
        size: "medium"
      }, /* @__PURE__ */React44.createElement("button", {
        ref: domRef,
        type: "button"
      }, data.linkGraphic && linkIconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React44.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), data.label, data.linkGraphic && linkIconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React44.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), /* @__PURE__ */React44.createElement("span", {
        className: "is-visually-hidden",
        "aria-hidden": data.label === accessibility
      }, accessibility)));
    case "ActivityMapDialogTrigger":
      var _data_staticMapImage;
      return /* @__PURE__ */React44.createElement(EGDSLayoutFlex4, {
        className: className
      }, /* @__PURE__ */React44.createElement(EGDSLink4, {
        onClickCapture: trackAnalytics
      }, /* @__PURE__ */React44.createElement("button", {
        ref: domRef,
        type: "button",
        onClick: openDialog,
        "aria-labelledby": accessibility
      }, /* @__PURE__ */React44.createElement(EGDSLayoutFlexItem4, {
        minWidth: "full_width"
      }, /* @__PURE__ */React44.createElement(EGDSCard, {
        border: true
      }, ((_data_staticMapImage = data.staticMapImage) === null || _data_staticMapImage === void 0 ? void 0 : _data_staticMapImage.url) && /* @__PURE__ */React44.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R21_9
      }, /* @__PURE__ */React44.createElement(EGDSImage, {
        src: data.staticMapImage.url,
        alt: data.staticMapImage.accessibility || ""
      })), data.mapTriggerLabel && /* @__PURE__ */React44.createElement(EGDSCardContentSection, null, /* @__PURE__ */React44.createElement(EGDSLayoutFlex4, {
        justifyContent: "center"
      }, data.mapTriggerLabel)))))));
    default:
      return null;
  }
};
ActivityDialogTrigger.displayName = "ActivityDialogTrigger";
ActivityDialogTrigger.fragment = __Fragment12;
// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
var __Fragment13 = gql52(_templateObject51(), __EGDSDatePickerContentFragment, __DateFragment, ActivityDialogTrigger.fragment);
var ActivityDateRangePickerDialog = function (param) {
  var className = param.className,
    onSubmitHandler = param.onSubmitHandler,
    data = param.data,
    isNestedDialog = param.isNestedDialog;
  var formatDateString = useLocalization().formatDateString;
  var dialogKey = React45.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  var _useDialog2 = _sliced_to_array(useDialog2("activity-date-range-picker-dialog-".concat(dialogKey), nestedDialogKey), 3),
    isDialogOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    DialogComponent = _useDialog2[2];
  var _data_dateRangePicker = data.dateRangePicker,
    buttonText = _data_dateRangePicker.buttonText,
    firstDayOfWeek = _data_dateRangePicker.firstDayOfWeek,
    footerText = _data_dateRangePicker.footerText,
    sameDaySelectionAllowed = _data_dateRangePicker.sameDaySelectionAllowed,
    selectedEndDate = _data_dateRangePicker.selectedEndDate,
    selectedStartDate = _data_dateRangePicker.selectedStartDate,
    validDaysLowerBoundInclusive = _data_dateRangePicker.validDaysLowerBoundInclusive,
    validDaysUpperBoundInclusive = _data_dateRangePicker.validDaysUpperBoundInclusive,
    dateFormat = _data_dateRangePicker.dateFormat,
    datePickerContent = _data_dateRangePicker.datePickerContent,
    trigger = data.trigger;
  var today = /* @__PURE__ */new Date();
  var tomorrow = /* @__PURE__ */new Date();
  tomorrow.setDate(today.getDate() + 1);
  var defaultDaysBookableInAdvance = 500;
  var dateRangePickerTrigger = React45.createRef();
  var _React45_useState = _sliced_to_array(React45.useState(formatDateString(today, {
      raw: dateFormat
    })), 2),
    startDate = _React45_useState[0],
    setStartDate = _React45_useState[1];
  var _React45_useState1 = _sliced_to_array(React45.useState(formatDateString(tomorrow, {
      raw: dateFormat
    })), 2),
    endDate = _React45_useState1[0],
    setEndDate = _React45_useState1[1];
  var _React45_useState2 = _sliced_to_array(React45.useState(formatDateString(today, {
      raw: dateFormat
    })), 2),
    validStartDate = _React45_useState2[0],
    setValidStartDate = _React45_useState2[1];
  var _React45_useState3 = _sliced_to_array(React45.useState(defaultDaysBookableInAdvance), 2),
    daysBookableInAdvance = _React45_useState3[0],
    setDaysBookableInAdvance = _React45_useState3[1];
  var _React45_useState4 = _sliced_to_array(React45.useState(void 0), 2),
    datePickerContentMap = _React45_useState4[0],
    setDatePickerContentMap = _React45_useState4[1];
  React45.useEffect(function () {
    var dateFormatOptions = {
      raw: dateFormat
    };
    if (selectedStartDate) {
      setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
    }
    if (selectedEndDate) {
      setEndDate(formatDateString(convertToDateObject(selectedEndDate), dateFormatOptions));
    }
    if (validDaysLowerBoundInclusive) {
      setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
    }
    if (validDaysUpperBoundInclusive) {
      var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */new Date().getTime();
      setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
    }
    if (datePickerContent === null || datePickerContent === void 0 ? void 0 : datePickerContent.length) {
      var newDatePickerContent = datePickerContent.reduce(function (contentMap, content) {
        return _object_spread({}, contentMap, getDatePickerContent(content));
      }, {});
      setDatePickerContentMap(newDatePickerContent);
    }
  }, [formatDateString, selectedEndDate, selectedStartDate, validDaysLowerBoundInclusive, validDaysUpperBoundInclusive, dateFormat, datePickerContent]);
  var onDismissCB = React45.useCallback(function () {
    dialogActions.closeDialog();
    if (dateRangePickerTrigger.current && typeof dateRangePickerTrigger.current.focus === "function") {
      dateRangePickerTrigger.current.focus();
    }
  }, [dialogActions, dateRangePickerTrigger]);
  var onSubmitCB = React45.useCallback(function (start, end) {
    var newEndDate = end || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
    var startDateFormatted = formatDateString(start, {
      raw: dateFormat
    });
    var endDateFormatted = formatDateString(newEndDate, {
      raw: dateFormat
    });
    setStartDate(startDateFormatted);
    setEndDate(endDateFormatted);
    onSubmitHandler(startDateFormatted, endDateFormatted);
    onDismissCB();
  }, [dateFormat, formatDateString, onDismissCB, onSubmitHandler]);
  var dateFieldProps = {
    showDatePicker: true,
    useCustomTrigger: true
  };
  var datePickerProps = {
    buttonText: buttonText,
    dateFieldProps: dateFieldProps,
    datePickerContent: datePickerContentMap,
    daysBookableInAdvance: daysBookableInAdvance,
    doubleMonths: true,
    endDate: endDate,
    firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
    footerText: footerText !== null && footerText !== void 0 ? footerText : void 0,
    onDismissCB: onDismissCB,
    onSubmitCB: onSubmitCB,
    renderType: EGDSDatePickerRenderType.DIALOG,
    singleDateSelect: sameDaySelectionAllowed,
    startDate: startDate,
    triggeredSelector: EGDSDatePickerTriggeredSelector.START,
    validStartDate: validStartDate
  };
  return /* @__PURE__ */React45.createElement(React45.Fragment, null, /* @__PURE__ */React45.createElement(ActivityDialogTrigger, {
    className: className,
    domRef: dateRangePickerTrigger,
    linkIconPosition: "LEADING" /* LEADING */,
    openDialog: dialogActions.openDialog,
    data: trigger
  }), /* @__PURE__ */React45.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React45.createElement(DialogComponent, null, /* @__PURE__ */React45.createElement(EGDSDatePicker, _object_spread({}, datePickerProps)))));
};
ActivityDateRangePickerDialog.displayName = "ActivityDateRangePickerDialog";
ActivityDateRangePickerDialog.fragment = __Fragment13;
// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
import React46 from "react";
import { gql as gql54 } from "@apollo/client";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
// ../internal/src/components/actions/activity-click-action.ts
import { gql as gql53 } from "@apollo/client";
var __ActivityClickActionsFragment = gql53(_templateObject52());
var getClickAction = function (data, clickTracker, closeDialog) {
  switch (data.__typename) {
    case "ActivityLinkClickAction":
      {
        var linkDialog = function () {
          var clientSideAnalytics = data.clientSideAnalytics,
            linkTagUrl = data.linkTagUrl,
            opensInNewTab = data.opensInNewTab;
          clickTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
          if (linkTagUrl) {
            window.open(linkTagUrl, opensInNewTab ? "_blank" : "_self");
          }
        };
        return {
          onClick: linkDialog
        };
      }
    case "ActivityRefClickAction":
      return {
        href: "#".concat(data.sectionRef)
      };
    case "ActivityCloseDialogClickAction":
      return {
        onClick: closeDialog
      };
    case "ActivitySelectionClickAction":
      {
        var tabSelection = function () {
          var clientSideAnalytics = data.clientSideAnalytics,
            selectionList = data.selectionList;
          clickTracker(clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.linkName);
          if (selectionList) {
            return selectionList;
          }
        };
        return {
          selectedTabAction: tabSelection()
        };
      }
    case "ActivityPaginationInfoAction":
      {
        var clientSideAnalytics = data.clientSideAnalytics,
          pagination = data.pagination;
        clickTracker(clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.linkName);
        return {
          paginatedIndex: pagination
        };
      }
    default:
      return null;
  }
};
// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
var __Fragment14 = gql54(_templateObject53(), __ActivityClickActionsFragment, ActivityDialogTrigger.fragment, __EGDSDialogFooterFragment, ActivitiesEGDSText.fragment);
var ActivityDisclaimerDialog = function (param) {
  var className = param.className,
    data = param.data,
    dialogIdSuffix = param.dialogIdSuffix,
    linkIconPosition = param.linkIconPosition;
  var contents = data.contents,
    dialog = data.dialog,
    trigger = data.trigger,
    dialogActions = data.dialogActions;
  var clickTracker = useClickTracker11();
  var randomDialogKey = React46.useMemo(function () {
    return Math.random().toString(36).substr(2, 5);
  }, []);
  var dialogKey = dialogIdSuffix !== null && dialogIdSuffix !== void 0 ? dialogIdSuffix : randomDialogKey;
  var _useDialog3 = _sliced_to_array(useDialog3("activity-disclaimer-dialog-".concat(dialogKey), "nestedActivityDisclaimerDialog"), 3),
    isDialogOpen = _useDialog3[0],
    dialogComponentActions = _useDialog3[1],
    DialogComponent = _useDialog3[2];
  var dialogActionMap = dialogActions === null || dialogActions === void 0 ? void 0 : dialogActions.map(function (dialogAction) {
    return getClickAction(dialogAction, clickTracker, dialogComponentActions.closeDialog);
  });
  var activityLinkDialogTrigger = React46.createRef();
  var closeDialog = React46.useCallback(function () {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    if (activityLinkDialogTrigger.current && typeof activityLinkDialogTrigger.current.focus === "function") {
      activityLinkDialogTrigger.current.focus();
    }
    dialogComponentActions.closeDialog();
  }, [dialogComponentActions, clickTracker, dialog.closeAnalytics]);
  return /* @__PURE__ */React46.createElement(React46.Fragment, null, /* @__PURE__ */React46.createElement(ActivityDialogTrigger, {
    className: className,
    domRef: activityLinkDialogTrigger,
    openDialog: dialogComponentActions.openDialog,
    data: trigger,
    linkIconPosition: linkIconPosition
  }), /* @__PURE__ */React46.createElement(EGDSSheetTransition3, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React46.createElement(DialogComponent, null, /* @__PURE__ */React46.createElement(EGDSDialog2, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true
  }, /* @__PURE__ */React46.createElement(EGDSDialogContent2, null, contents.map(function (content, index) {
    return /* @__PURE__ */React46.createElement(ActivitiesEGDSText, {
      key: "disclaimer-dialog-contents-".concat(index),
      data: content
    });
  }), /* @__PURE__ */React46.createElement(ActivitiesEGDSDialogFooter, {
    data: dialog.footer,
    dialogActionMap: dialogActionMap,
    closeDialog: closeDialog
  }))))));
};
ActivityDisclaimerDialog.displayName = "ActivityDisclaimerDialog";
ActivityDisclaimerDialog.fragment = __Fragment14;
// ../internal/src/components/activity-dialog/activity-traveler-selection-dialog.tsx
import React47 from "react";
import { gql as gql55 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSFloatingFullWidthButton } from "@egds/react-core/button";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var __Fragment15 = gql55(_templateObject54(), ActivityDialogTrigger.fragment, ActivitiesEGDSHeading.fragment, EGDSTravelersStepInput.fragment, EGDSDialogToolbar.fragment, EGDSGraphicText.fragment);
var headingMargin = {
  blockend: "two"
};
var ActivityTravelerSelectorDialog = function (param) {
  var className = param.className,
    doneClickHandler = param.doneClickHandler,
    data = param.data,
    isNestedDialog = param.isNestedDialog,
    autoFocus = param.autoFocus;
  var clickTracker = useClickTracker12();
  var heading = data.heading,
    dialog = data.dialog,
    doneButton = data.doneButton,
    ticketsStepInput = data.ticketsStepInput,
    trigger = data.trigger,
    errorMessageForSelectedTickets = data.errorMessageForSelectedTickets;
  var _React47_useState = _sliced_to_array(React47.useState(), 2),
    ticket = _React47_useState[0],
    setTicketValue = _React47_useState[1];
  var randomDialogKey = React47.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  var _useDialog4 = _sliced_to_array(useDialog4("activity-traveler-selection-dialog-".concat(randomDialogKey), nestedDialogKey), 3),
    isDialogOpen = _useDialog4[0],
    dialogActions = _useDialog4[1],
    DialogComponent = _useDialog4[2];
  var triggerRef = React47.useRef(null);
  var _React47_useState1 = _sliced_to_array(React47.useState(false), 2),
    isDoneButtonDisabled = _React47_useState1[0],
    setIsDoneButtonDisabled = _React47_useState1[1];
  var intialTickets = React47.useMemo(function () {
    var travelerTicket = [];
    ticketsStepInput.forEach(function (step) {
      var _step_key;
      var travlerData = {
        code: (_step_key = step.key) !== null && _step_key !== void 0 ? _step_key : "",
        count: step.value
      };
      travelerTicket.push(travlerData);
    });
    setTicketValue(travelerTicket);
    return travelerTicket;
  }, [ticketsStepInput]);
  var onTravelerSelector = React47.useCallback(function (value, key, countIndex) {
    intialTickets[countIndex] = {
      code: key !== null && key !== void 0 ? key : "",
      count: value
    };
    setTicketValue(intialTickets);
    var atLeastOneTicketCount = intialTickets.find(function (t) {
      return t.count > 0;
    });
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
  }, [intialTickets]);
  var closeToolbarAction = React47.useCallback(function () {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialog.closeAnalytics, clickTracker]);
  var onClick = React47.useCallback(function () {
    var _doneButton_action;
    doneClickHandler(ticket !== null && ticket !== void 0 ? ticket : []);
    if ((_doneButton_action = doneButton.action) === null || _doneButton_action === void 0 ? void 0 : _doneButton_action.analytics) {
      clickTracker(doneButton.action.analytics.referrerId, doneButton.action.analytics.linkName);
    }
    dialogActions.closeDialog();
  }, [doneClickHandler, ticket]);
  var openDialog = React47.useCallback(function () {
    var atLeastOneTicketCount = ticketsStepInput.find(function (t) {
      return t.value > 0;
    });
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
    dialogActions.openDialog();
  }, []);
  var renderTravelerSelectionDialog = function (viewportType) {
    return /* @__PURE__ */React47.createElement(EGDSSheet, {
      type: viewportType,
      isVisible: true,
      returnFocusOnClose: true,
      triggerRef: triggerRef
    }, /* @__PURE__ */React47.createElement(EGDSDialogToolbar, {
      toolbarType: "close",
      toolbarAction: closeToolbarAction,
      data: dialog.toolbar
    }), /* @__PURE__ */React47.createElement(EGDSSheetContent, null, heading && /* @__PURE__ */React47.createElement(EGDSSpacing7, {
      margin: headingMargin
    }, /* @__PURE__ */React47.createElement(ActivitiesEGDSHeading, {
      size: 6,
      data: heading
    })), ticketsStepInput.map(function (count, index) {
      return /* @__PURE__ */React47.createElement(EGDSTravelersStepInput, {
        key: index,
        countIndex: index,
        onChange: onTravelerSelector,
        data: count
      });
    }), /* @__PURE__ */React47.createElement(EGDSSpacing7, {
      margin: {
        blockstart: "three"
      }
    }, isDoneButtonDisabled && errorMessageForSelectedTickets ? /* @__PURE__ */React47.createElement(EGDSGraphicText, {
      data: errorMessageForSelectedTickets
    }) : /* @__PURE__ */React47.createElement("div", null, "\xA0")), /* @__PURE__ */React47.createElement(EGDSSpacing7, {
      margin: {
        blockstart: "six"
      }
    }, /* @__PURE__ */React47.createElement(EGDSFloatingFullWidthButton, {
      size: EGDSButtonSize2.LARGE,
      onClick: onClick,
      disabled: isDoneButtonDisabled
    }, doneButton.primary))));
  };
  return /* @__PURE__ */React47.createElement(React47.Fragment, null, /* @__PURE__ */React47.createElement(ActivityDialogTrigger, {
    className: className,
    openDialog: openDialog,
    data: trigger,
    domRef: triggerRef,
    autoFocus: autoFocus
  }), /* @__PURE__ */React47.createElement(EGDSSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React47.createElement(DialogComponent, null, /* @__PURE__ */React47.createElement(Viewport, null, /* @__PURE__ */React47.createElement(ViewSmall, null, renderTravelerSelectionDialog("full" /* FULL_SCREEN */)), /* @__PURE__ */React47.createElement(ViewMedium, null, renderTravelerSelectionDialog("centered" /* CENTERED */))))));
};
ActivityTravelerSelectorDialog.displayName = "ActivityTravelerSelectorDialog";
ActivityTravelerSelectorDialog.fragment = __Fragment15;
// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
import React51 from "react";
import { gql as gql59 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3, EGDSFloatingFullWidthButton as EGDSFloatingFullWidthButton2 } from "@egds/react-core/button";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
import React50 from "react";
import { gql as gql58 } from "@apollo/client";
import { EGDSRadioButtonGroup } from "@egds/react-core/radio-button";
// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
import React49 from "react";
import { gql as gql57 } from "@apollo/client";
// ../internal/src/components/egds-radio-group/egds-basic-radio-button.tsx
import React48 from "react";
import { gql as gql56 } from "@apollo/client";
import { EGDSRadioButton } from "@egds/react-core/radio-button";
var __Fragment16 = gql56(_templateObject55());
var EGDSBasicRadioButton = function (param) {
  var data = param.data,
    groupName = param.groupName;
  var description = data.description,
    disabled = data.disabled,
    label = data.label,
    labelSuffix = data.labelSuffix,
    value = data.value;
  return /* @__PURE__ */React48.createElement(EGDSRadioButton, {
    key: "".concat(groupName, "-").concat(value),
    disabled: disabled,
    id: value,
    value: value,
    description: description !== null && description !== void 0 ? description : void 0,
    label: label,
    labelSuffix: labelSuffix !== null && labelSuffix !== void 0 ? labelSuffix : void 0
  });
};
EGDSBasicRadioButton.displayName = "EGDSBasicRadioButton";
EGDSBasicRadioButton.fragment = __Fragment16;
// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
var _Fragment2 = gql57(_templateObject56(), EGDSBasicRadioButton.fragment);
var ActivitiesEGDSRadioButton = function (param) {
  var data = param.data,
    groupName = param.groupName;
  switch (data.__typename) {
    case "EGDSBasicRadioButton":
      return /* @__PURE__ */React49.createElement(EGDSBasicRadioButton, {
        groupName: groupName,
        data: data
      });
    default:
      return null;
  }
};
ActivitiesEGDSRadioButton.displayName = "ActivitiesEGDSRadioButton";
ActivitiesEGDSRadioButton.fragment = _Fragment2;
// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
var __Fragment17 = gql58(_templateObject57(), ActivitiesEGDSRadioButton.fragment);
var EGDSBasicRadioGroup = function (param) {
  var data = param.data,
    onChange = param.onChange;
  var groupName = data.groupName,
    selected = data.selected,
    options = data.options;
  return /* @__PURE__ */React50.createElement(EGDSRadioButtonGroup, {
    group: groupName,
    onChange: onChange,
    selected: selected !== null && selected !== void 0 ? selected : void 0,
    defaultChecked: true
  }, options.map(function (option, index) {
    return /* @__PURE__ */React50.createElement(ActivitiesEGDSRadioButton, {
      key: "egds-radio-group-".concat(index),
      data: option,
      groupName: groupName
    });
  }));
};
EGDSBasicRadioGroup.displayName = "EGDSBasicRadioGroup";
EGDSBasicRadioGroup.fragment = __Fragment17;
// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
var __Fragment18 = gql59(_templateObject58(), ActivityDialogTrigger.fragment, ActivitiesEGDSHeading.fragment, EGDSBasicRadioGroup.fragment, EGDSDialogToolbar.fragment);
var headingMargin2 = {
  blockend: "two"
};
var ActivityRadioGroupDialog = function (param) {
  var className = param.className,
    doneClickHandler = param.doneClickHandler,
    data = param.data,
    isNestedDialog = param.isNestedDialog;
  var heading = data.heading,
    dialog = data.dialog,
    _data_doneButton = data.doneButton,
    action = _data_doneButton.action,
    primary = _data_doneButton.primary,
    radioGroup = data.radioGroup,
    trigger = data.trigger;
  var clickTracker = useClickTracker13();
  var dialogKey = React51.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  var _useDialog5 = _sliced_to_array(useDialog5("activity-radio-dialog-".concat(dialogKey), nestedDialogKey), 3),
    isDialogOpen = _useDialog5[0],
    dialogActions = _useDialog5[1],
    DialogComponent = _useDialog5[2];
  var _radioGroup_selected;
  var _React51_useState = _sliced_to_array(React51.useState((_radioGroup_selected = radioGroup.selected) !== null && _radioGroup_selected !== void 0 ? _radioGroup_selected : ""), 2),
    selectedValue = _React51_useState[0],
    setSelectedValue = _React51_useState[1];
  var triggerRef = React51.useRef(null);
  var handleOnChange = function (event) {
    setSelectedValue(event.target.value);
  };
  var handleToolbarAction = React51.useCallback(function () {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialogActions, dialog.closeAnalytics, clickTracker]);
  var handleDoneOnClick = React51.useCallback(function () {
    if (action === null || action === void 0 ? void 0 : action.analytics) {
      clickTracker(action.analytics.referrerId, action.analytics.linkName);
    }
    doneClickHandler(radioGroup.groupName, selectedValue);
    dialogActions.closeDialog();
  }, [doneClickHandler, clickTracker, action === null || action === void 0 ? void 0 : action.analytics, dialogActions, radioGroup.groupName, selectedValue]);
  return /* @__PURE__ */React51.createElement(React51.Fragment, null, /* @__PURE__ */React51.createElement(ActivityDialogTrigger, {
    className: className,
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React51.createElement(EGDSSheetTransition5, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React51.createElement(DialogComponent, null, /* @__PURE__ */React51.createElement(EGDSSheet2, {
    type: "centered",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React51.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: handleToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React51.createElement(EGDSSheetContent2, null, heading && /* @__PURE__ */React51.createElement(EGDSSpacing8, {
    margin: headingMargin2
  }, /* @__PURE__ */React51.createElement(ActivitiesEGDSHeading, {
    size: 6,
    data: heading
  })), /* @__PURE__ */React51.createElement(EGDSBasicRadioGroup, {
    onChange: handleOnChange,
    data: radioGroup
  }), /* @__PURE__ */React51.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React51.createElement(EGDSFloatingFullWidthButton2, {
    size: EGDSButtonSize3.LARGE,
    onClick: handleDoneOnClick
  }, primary)))))));
};
ActivityRadioGroupDialog.displayName = "ActivityRadioGroupDialog";
ActivityRadioGroupDialog.fragment = __Fragment18;
// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
import React58 from "react";
import { gql as gql65 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent3 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
import React56, { useRef } from "react";
import { gql as gql64 } from "@apollo/client";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing12, EGDSSpacingHr } from "@egds/react-core/spacing";
// ../internal/src/utils/utils.ts
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";
var randomKey = Math.random().toString(36).substr(2, 5);
function useQueryParams() {
  var location = useLocation();
  var searchParams = useMemo(function () {
    return new URLSearchParams(location.search);
  }, [location.search]);
  return searchParams;
}
function useDeleteParam() {
  var navigate = useNavigate();
  var location = useLocation();
  return useCallback(function (key) {
    var params = new URLSearchParams(location.search);
    params.delete(key);
    navigate("".concat(location.pathname, "?").concat(params), {
      replace: true
    });
  }, [navigate, location]);
}
// ../internal/src/components/activity-reviews-comment/activity-reviews-comment.tsx
import React52 from "react";
import { gql as gql60 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText10 } from "@egds/react-core/text";
var __Fragment19 = gql60(_templateObject59(), ActivitiesEGDSExpando.fragment, ActivitiesEGDSText.fragment);
var topMargin3 = {
  blockstart: "two"
};
var ReviewCommentsWrapper = React52.memo(function (param) {
  var expando = param.expando,
    text = param.text;
  return /* @__PURE__ */React52.createElement(React52.Fragment, null, expando ? /* @__PURE__ */React52.createElement(EGDSSpacing9, {
    margin: topMargin3
  }, /* @__PURE__ */React52.createElement(ActivitiesEGDSExpando, {
    expandoPeekLines: 4,
    data: expando
  }, /* @__PURE__ */React52.createElement(EGDSText10, {
    overflow: "wrap",
    size: 300
  }, text))) : /* @__PURE__ */React52.createElement(EGDSSpacing9, {
    margin: topMargin3
  }, /* @__PURE__ */React52.createElement(EGDSText10, {
    size: 300
  }, text)));
});
ReviewCommentsWrapper.displayName = "ReviewCommentsWrapper";
var ActivityReviewsComment = function (param) {
  var className = param.className,
    headingSize = param.headingSize,
    headingTag = param.headingTag,
    data = param.data;
  var author = data.author,
    overallScoreMessage = data.overallScoreMessage,
    reviewedOn = data.reviewedOn,
    formattedSubmissionDate = data.formattedSubmissionDate,
    formattedActivityDate = data.formattedActivityDate,
    userLocation = data.userLocation,
    text = data.text,
    expando = data.expando;
  return /* @__PURE__ */React52.createElement("div", {
    className: className
  }, overallScoreMessage && /* @__PURE__ */React52.createElement(ActivitiesEGDSText, {
    data: overallScoreMessage,
    headingSize: headingSize,
    headingTag: headingTag
  }), author && /* @__PURE__ */React52.createElement(EGDSSpacing9, {
    margin: topMargin3
  }, /* @__PURE__ */React52.createElement(EGDSHeading3, {
    tag: "h3",
    size: 6
  }, author)), reviewedOn && /* @__PURE__ */React52.createElement(EGDSText10, {
    size: 300
  }, reviewedOn), formattedSubmissionDate && /* @__PURE__ */React52.createElement(EGDSText10, {
    size: 300
  }, formattedSubmissionDate), userLocation && /* @__PURE__ */React52.createElement(EGDSText10, {
    size: 300
  }, userLocation), /* @__PURE__ */React52.createElement(ReviewCommentsWrapper, {
    expando: expando,
    text: text
  }), formattedActivityDate && /* @__PURE__ */React52.createElement(EGDSSpacing9, {
    margin: topMargin3
  }, /* @__PURE__ */React52.createElement(EGDSText10, {
    size: 200
  }, formattedActivityDate)));
};
ActivityReviewsComment.displayName = "ActivityReviewsCommentList";
ActivityReviewsComment.fragment = __Fragment19;
// ../internal/src/components/activity-reviews-sort-tab/activity-reviews-sort-tab.tsx
import React53 from "react";
import { gql as gql61 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
var __Fragment20 = gql61(_templateObject60(), __ActivityClickActionsFragment);
var tabsMargin = {
  block: "two"
};
var ActivityReviewsSortTab = function (param) {
  var className = param.className,
    data = param.data,
    onClick = param.onClick;
  var heading = data.heading,
    tabs = data.tabs;
  var _React53_useState = _sliced_to_array(React53.useState(tabs.findIndex(function (tab) {
      return tab.selected;
    })), 2),
    activeTab = _React53_useState[0],
    setActiveTab = _React53_useState[1];
  var clickTracker = useClickTracker14();
  if (!tabs.length) {
    return null;
  }
  var handleTabChanges = function (tabIndex) {
    var _tabs_tabIndex;
    var selectedTab = (_tabs_tabIndex = tabs[tabIndex]) === null || _tabs_tabIndex === void 0 ? void 0 : _tabs_tabIndex.clickAction;
    var selectedAction = selectedTab ? getClickAction(selectedTab, clickTracker) : null;
    onClick(selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.selectedTabAction);
    setActiveTab(tabIndex);
  };
  return /* @__PURE__ */React53.createElement("div", {
    className: className
  }, heading && /* @__PURE__ */React53.createElement(EGDSHeading4, {
    tag: "h3",
    size: 6
  }, heading), /* @__PURE__ */React53.createElement(EGDSSpacing10, {
    margin: tabsMargin
  }, /* @__PURE__ */React53.createElement(EGDSTabs, {
    onTabSelect: handleTabChanges,
    selectedTab: activeTab,
    tabsType: EGDSTabsType.NATURAL,
    role: "tablist",
    withBorder: true
  }, tabs.map(function (sortType) {
    var _sortType_clickAction;
    var _sortType_clickAction_accessibilityText;
    return /* @__PURE__ */React53.createElement(EGDSTab, {
      name: sortType.label,
      key: sortType.label,
      targetURI: "#",
      tabLinkAttr: {
        "aria-label": (_sortType_clickAction_accessibilityText = (_sortType_clickAction = sortType.clickAction) === null || _sortType_clickAction === void 0 ? void 0 : _sortType_clickAction.accessibilityText) !== null && _sortType_clickAction_accessibilityText !== void 0 ? _sortType_clickAction_accessibilityText : ""
      }
    });
  }))));
};
ActivityReviewsSortTab.displayName = "ActivityReviewsSortTab";
ActivityReviewsSortTab.fragment = __Fragment20;
// ../internal/src/components/activity-reviews-summary/activity-reviews-summary.tsx
import React54 from "react";
import { gql as gql62 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
var __Fragment21 = gql62(_templateObject61(), ActivitiesEGDSText.fragment, ActivityDisclaimerDialog.fragment, EGDSStylizedText.fragment);
var disclaimerMargin = {
  inlinestart: "two",
  blockstart: "one"
};
var reviewMargin = {
  blockstart: "one"
};
var ActivityReviewsSummary = function (param) {
  var className = param.className,
    data = param.data,
    dialogIdSuffix = param.dialogIdSuffix,
    headingSize = param.headingSize,
    headingTag = param.headingTag;
  var averageScore = data.averageScore,
    disclaimer = data.disclaimer,
    sectionRef = data.sectionRef,
    reviewSuperlative = data.reviewSuperlative;
  var _ref = reviewSuperlative || {},
    superlativeSize = _ref.size;
  var ActivityReviewsRating = function () {
    return /* @__PURE__ */React54.createElement("div", {
      className: className,
      id: sectionRef !== null && sectionRef !== void 0 ? sectionRef : void 0
    }, /* @__PURE__ */React54.createElement(EGDSLayoutFlex5, null, /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React54.createElement(ActivitiesEGDSText, {
      data: averageScore,
      headingSize: headingSize,
      headingTag: headingTag,
      tabIndex: -1
    })), disclaimer && /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React54.createElement(EGDSSpacing11, {
      margin: disclaimerMargin
    }, /* @__PURE__ */React54.createElement(ActivityDisclaimerDialog, {
      data: disclaimer,
      dialogIdSuffix: dialogIdSuffix
    })))));
  };
  var ActivityHighlightReviewsRating = function () {
    var averageScoreSize = averageScore.textSize;
    return /* @__PURE__ */React54.createElement("div", {
      className: className,
      id: sectionRef !== null && sectionRef !== void 0 ? sectionRef : void 0
    }, /* @__PURE__ */React54.createElement(EGDSLayoutFlex5, {
      wrap: "wrap",
      direction: "column"
    }, /* @__PURE__ */React54.createElement(ActivitiesEGDSText, {
      data: averageScore,
      textSize: Number(averageScoreSize),
      tabIndex: -1
    }), reviewSuperlative && /* @__PURE__ */React54.createElement(EGDSSpacing11, {
      margin: reviewMargin
    }, /* @__PURE__ */React54.createElement(EGDSStylizedText, {
      data: reviewSuperlative,
      size: Number(superlativeSize)
    })), disclaimer && /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React54.createElement(EGDSSpacing11, {
      margin: reviewMargin
    }, /* @__PURE__ */React54.createElement(ActivityDisclaimerDialog, {
      data: disclaimer,
      dialogIdSuffix: dialogIdSuffix
    })))));
  };
  return dialogIdSuffix === "ActivityReviews" && averageScore && averageScore.__typename === "EGDSStylizedText" ? ActivityHighlightReviewsRating() : ActivityReviewsRating();
};
ActivityReviewsSummary.displayName = "ActivityReviewsSummary";
ActivityReviewsSummary.fragment = __Fragment21;
// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-more-button.tsx
import React55 from "react";
import { gql as gql63 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
var __Fragment22 = gql63(_templateObject62(), __ActivityClickActionsFragment, ActivitiesEGDSButton.fragment);
var ActivityReviewsMoreButton = function (param) {
  var data = param.data,
    fetchMoreAction = param.fetchMoreAction;
  var action = data.action,
    button = data.button;
  var tracker = useClickTracker15();
  var loadMoreReviews = React55.useCallback(function () {
    var selectedAction = getClickAction(action, tracker);
    fetchMoreAction(selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.paginatedIndex);
  }, [fetchMoreAction]);
  return /* @__PURE__ */React55.createElement(EGDSSecondaryButton2, {
    "data-stid": "more-reviews-button",
    onClick: loadMoreReviews
  }, button.primary);
};
ActivityReviewsMoreButton.displayName = "ActivityReviewsMoreButton";
ActivityReviewsMoreButton.fragment = __Fragment22;
// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
var __Fragment23 = gql64(_templateObject63(), ActivityReviewsComment.fragment, ActivityReviewsSummary.fragment, ActivityReviewsSortTab.fragment, ActivityReviewsMoreButton.fragment);
var reviewPadding = {
  small: {
    inline: "three",
    block: "twelve"
  },
  large: {
    inline: "twelve",
    block: "twelve"
  }
};
var reviewGrid = {
  large: ["1fr", "2fr"]
};
var showMorePadding = {
  blockstart: "six"
};
var ActivityReviewsDialogContent = function (param) {
  var data = param.data,
    fetchMoreAction = param.fetchMoreAction,
    handleSortTabClick = param.handleSortTabClick;
  var summary = data.summary,
    comments = data.comments,
    sortTabs = data.sortTabs,
    moreButton = data.moreButton;
  var scrollElementRef = useRef();
  var pageParams = useQueryParams();
  var deleteParam = useDeleteParam();
  var reviewId = pageParams !== void 0 ? pageParams.get("reviewId") : null;
  React56.useEffect(function () {
    if (reviewId) {
      var _scrollElementRef_current;
      var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      (_scrollElementRef_current = scrollElementRef.current) === null || _scrollElementRef_current === void 0 ? void 0 : _scrollElementRef_current.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start"
      });
      deleteParam("reviewId");
    }
  }, [reviewId]);
  if (!summary || !comments.length) {
    return null;
  }
  return /* @__PURE__ */React56.createElement(EGDSCard2, null, /* @__PURE__ */React56.createElement(EGDSSpacing12, {
    padding: reviewPadding
  }, /* @__PURE__ */React56.createElement(EGDSLayoutGrid, {
    columns: reviewGrid,
    space: "six"
  }, /* @__PURE__ */React56.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React56.createElement(ActivityReviewsSummary, {
    data: summary,
    dialogIdSuffix: "ActivityReviews",
    headingSize: 5
  })), /* @__PURE__ */React56.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React56.createElement("div", {
    key: "commentsSection"
  }, sortTabs && /* @__PURE__ */React56.createElement(ActivityReviewsSortTab, {
    key: "sortTabs",
    data: sortTabs,
    onClick: handleSortTabClick
  }), comments.map(function (comment, index) {
    return /* @__PURE__ */React56.createElement("div", {
      key: index,
      ref: index === Number(reviewId) ? scrollElementRef : null
    }, /* @__PURE__ */React56.createElement(ActivityReviewsComment, {
      key: "review-comment-".concat(index),
      data: comment
    }), /* @__PURE__ */React56.createElement(EGDSSpacingHr, {
      blockMargin: "six"
    }));
  }), moreButton && /* @__PURE__ */React56.createElement(EGDSSpacing12, {
    padding: showMorePadding
  }, /* @__PURE__ */React56.createElement(EGDSLayoutFlex6, {
    justifyContent: "center"
  }, /* @__PURE__ */React56.createElement(ActivityReviewsMoreButton, {
    fetchMoreAction: fetchMoreAction,
    data: moreButton
  }))))))));
};
ActivityReviewsDialogContent.displayName = "ActivityReviewsDialogContent";
ActivityReviewsDialogContent.fragment = __Fragment23;
// ../internal/src/components/activity-dialog/context/activity-reviews-context.tsx
import React57 from "react";
var ActivityReviewsContext = React57.createContext(void 0);
var useReviewsContentContext = function () {
  var context = React57.useContext(ActivityReviewsContext);
  if (!context) {
    return null;
  }
  return context;
};
// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
var __Fragment24 = gql65(_templateObject64(), EGDSDialogToolbar.fragment, ActivityDialogTrigger.fragment);
var ActivityReviewCommentsDialog = function (param) {
  var reviewsDialogContent = param.reviewsDialogContent,
    onMoreReviewsClickHandler = param.onMoreReviewsClickHandler,
    onSortTabClickHandler = param.onSortTabClickHandler,
    dialogId = param.dialogId,
    openDialogCallBackHandler = param.openDialogCallBackHandler,
    _param_data = param.data,
    dialog = _param_data.dialog,
    trigger = _param_data.trigger;
  var _useReviewsContentContext;
  var closeAnalytics = dialog.closeAnalytics,
    toolbar = dialog.toolbar;
  var clickTracker = useClickTracker16();
  var dialogIdentifier = "ActivityReviewCommentsDialog-".concat(dialogId);
  var _useDialog6 = _sliced_to_array(useDialog6(dialogIdentifier, "nestedReviewCommentsDialog"), 3),
    isDialogOpen = _useDialog6[0],
    dialogActions = _useDialog6[1],
    DialogComponent = _useDialog6[2];
  var ActivityReviewsContent = (_useReviewsContentContext = useReviewsContentContext()) === null || _useReviewsContentContext === void 0 ? void 0 : _useReviewsContentContext.ActivityReviewsContent;
  var triggerRef = React58.useRef(null);
  var toolbarAction = function () {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  var dialogTriggerAction = function () {
    dialogActions.openDialog();
    if (openDialogCallBackHandler) {
      openDialogCallBackHandler();
    }
  };
  return /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement(EGDSLayoutFlex7, null, /* @__PURE__ */React58.createElement(ActivityDialogTrigger, {
    openDialog: dialogTriggerAction,
    data: trigger,
    domRef: triggerRef
  })), /* @__PURE__ */React58.createElement(EGDSSheetTransition6, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React58.createElement(DialogComponent, null, /* @__PURE__ */React58.createElement(EGDSSheet3, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React58.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction: toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React58.createElement(EGDSDialogContent3, null, reviewsDialogContent && onMoreReviewsClickHandler && onSortTabClickHandler ? /* @__PURE__ */React58.createElement(ActivityReviewsDialogContent, {
    fetchMoreAction: onMoreReviewsClickHandler,
    handleSortTabClick: onSortTabClickHandler,
    data: reviewsDialogContent
  }) : ActivityReviewsContent && /* @__PURE__ */React58.createElement(ActivityReviewsContent, null))))));
};
ActivityReviewCommentsDialog.displayName = "ActivityReviewCommentsDialog";
ActivityReviewCommentsDialog.fragment = __Fragment24;
// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
import React62 from "react";
import { gql as gql70 } from "@apollo/client";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
// ../internal/src/components/activity-map/activity-map.tsx
import React61 from "react";
import { gql as gql69 } from "@apollo/client";
// ../../map/google-maps-sdk-version-provider/src/components/google-maps-sdk-version-provider/google-maps-sdk-version-provider.tsx
import React59, { createContext, useContext, useMemo as useMemo2 } from "react";
var GoogleMapsSdkVersionContext = createContext({
  version: void 0
});
var useGoogleMapsSdkVersion = function () {
  return useContext(GoogleMapsSdkVersionContext);
};
function GoogleMapsSdkVersionProvider(param) {
  var version = param.version,
    children = param.children;
  var memoizedVersion = useMemo2(function () {
    return {
      version: version
    };
  }, [version]);
  return /* @__PURE__ */React59.createElement(GoogleMapsSdkVersionContext.Provider, {
    value: memoizedVersion
  }, children);
}
GoogleMapsSdkVersionProvider.displayName = "sharedui-GoogleMapsSdkVersionProvider";
// ../internal/src/components/activity-map/activity-map.tsx
import { UitkEGMaps, UitkEGMapsType } from "uitk-react-map";
// ../internal/src/components/activity-map/__private/utils/get-qualifiers.ts
import { EGDSEGMapsQualifier } from "@egds/react-core/map";
var egMapsIconTypeMapper = {
  hotel: EGDSEGMapsQualifier.HOTEL,
  people: EGDSEGMapsQualifier.PEOPLE,
  activity: EGDSEGMapsQualifier.ACTIVITY,
  focal: EGDSEGMapsQualifier.FOCAL
};
var getQualifiers = function (qualifiers) {
  return qualifiers.map(function (qualifier) {
    return egMapsIconTypeMapper[qualifier] || egMapsIconTypeMapper.hotel;
  });
};
// ../internal/src/components/activity-map/__private/utils/get-feature-object.ts
var getFeatureObject = function (marker, index) {
  var markerStatus = marker.markerStatus,
    markerIconType = marker.markerIconType,
    markerPosition = marker.markerPosition,
    placeCard = marker.placeCard,
    markerType = marker.markerType,
    text = marker.text;
  var commonFields = {
    id: index,
    qualifiers: getQualifiers(markerIconType),
    lat: markerPosition.latitude,
    lng: markerPosition.longitude,
    thumbnail: placeCard === null || placeCard === void 0 ? void 0 : placeCard.image
  };
  switch (markerType) {
    case "property":
    // property is deprecated and will fallback to default when returned from experience layer
    case "product":
      return _object_spread({
        type: "product",
        status: markerStatus.toLowerCase(),
        price: text
      }, commonFields);
    case "place":
      return _object_spread({
        type: "place",
        status: "unknown",
        text: text
      }, commonFields);
    default:
      return _object_spread({
        type: "place",
        status: "unknown",
        text: text
      }, commonFields);
  }
};
// ../internal/src/components/activity-map/__private/map-marker.ts
import { gql as gql67 } from "@apollo/client";
// ../internal/src/components/activity-map/__private/activity-map-place-card.tsx
import React60 from "react";
import { gql as gql66 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet4, EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
var fragment26 = gql66(_templateObject65(), ActivitiesEGDSText.fragment);
var gridColumnsWithImage = ["1fr", "3fr"];
var gridColumns = ["1fr"];
var ActivityMapPlaceCard = function (param) {
  var className = param.className,
    data = param.data;
  if (!data) {
    return null;
  }
  var image = data.image,
    primary = data.primary,
    secondaries = data.secondaries,
    tag = data.tag;
  return /* @__PURE__ */React60.createElement(EGDSSheetTransition7, {
    isVisible: true
  }, /* @__PURE__ */React60.createElement(EGDSSheet4, {
    className: className,
    isVisible: true,
    triggerRef: null
  }, /* @__PURE__ */React60.createElement(EGDSLayoutGrid2, {
    columns: image ? gridColumnsWithImage : gridColumns
  }, image && /* @__PURE__ */React60.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React60.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R16_9
  }, /* @__PURE__ */React60.createElement(EGDSImage2, {
    alt: image.description,
    src: image.url,
    placeholderImage: true
  }))), /* @__PURE__ */React60.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React60.createElement(EGDSSpacing13, {
    padding: "three"
  }, /* @__PURE__ */React60.createElement(EGDSLayoutFlex8, {
    direction: "column",
    space: "one"
  }, tag && /* @__PURE__ */React60.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React60.createElement(ActivitiesEGDSText, {
    data: tag
  })), primary && /* @__PURE__ */React60.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React60.createElement(ActivitiesEGDSText, {
    data: primary
  })), secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function (secondary, key) {
    return /* @__PURE__ */React60.createElement(EGDSLayoutFlexItem6, {
      key: "map-place-card-secondaries".concat(key)
    }, /* @__PURE__ */React60.createElement(ActivitiesEGDSText, {
      data: secondary
    }));
  })))))));
};
ActivityMapPlaceCard.fragment = fragment26;
ActivityMapPlaceCard.displayName = "ActivityMapPlaceCard";
// ../internal/src/components/activity-map/__private/map-marker.ts
var __MapMarkersFragment = gql67(_templateObject66(), ActivityMapPlaceCard.fragment);
// ../internal/src/components/activity-map/egds-dynamic-map-config.ts
import { gql as gql68 } from "@apollo/client";
var __EGDSDynamicMapConfigFragment = gql68(_templateObject67());
// ../internal/src/components/activity-map/activity-map.tsx
var fragment27 = gql69(_templateObject68(), __EGDSDynamicMapConfigFragment, __MapMarkersFragment);
var ActivityMap = function (param) {
  var data = param.data,
    dynamicMapSize = param.dynamicMapSize;
  var _useGoogleMapsSdkVersion;
  var egMap = data.egMap,
    markers = data.markers;
  var config = egMap.config;
  var _React61_useState = _sliced_to_array(React61.useState(null), 2),
    setSelectedMarker = _React61_useState[1];
  var _React61_useState1 = _sliced_to_array(React61.useState(null), 2),
    placeCard = _React61_useState1[0],
    setPlaceCard = _React61_useState1[1];
  var accessToken = config.__typename === "EGDSDynamicMapConfig" ? config.accessToken : "";
  var mapFeatures = markers.map(function (marker, index) {
    return getFeatureObject(marker, index);
  });
  var coordinates = mapFeatures.filter(function (f) {
    return f.lat !== void 0 && f.lng !== void 0;
  }).map(function (feature) {
    return {
      lat: feature.lat || 0,
      lng: feature.lng || 0
    };
  });
  var onMarkerSelectionChanged = React61.useCallback(function (event) {
    var action = event.action,
      feature = event.feature;
    switch (action) {
      case "clearSelection":
        setSelectedMarker(null);
        setPlaceCard(null);
        break;
      case "select":
        var _markers_feature_id;
        setSelectedMarker(feature);
        setPlaceCard((_markers_feature_id = markers[feature.id]) === null || _markers_feature_id === void 0 ? void 0 : _markers_feature_id.placeCard);
        break;
      default:
        break;
    }
  }, [markers]);
  var beforeInit = React61.useCallback(function (map) {
    map.addSelectionChangeListener(onMarkerSelectionChanged, "selectionChanged");
  }, [onMarkerSelectionChanged]);
  var initialViewport = {
    useBoundsComputation: true,
    coordinates: coordinates.length > 0 ? coordinates : void 0
  };
  var mapConfig = React61.useMemo(function () {
    return {
      markers: {
        product: {
          markerType: {
            available: "pin"
          }
        }
      }
    };
  }, []);
  var googleMapsSdkVersion = (_useGoogleMapsSdkVersion = useGoogleMapsSdkVersion()) === null || _useGoogleMapsSdkVersion === void 0 ? void 0 : _useGoogleMapsSdkVersion.version;
  return /* @__PURE__ */React61.createElement(UitkEGMaps, {
    accessToken: accessToken,
    mapType: UitkEGMapsType.GOOGLE,
    mapTypeVersion: googleMapsSdkVersion,
    features: mapFeatures,
    height: dynamicMapSize,
    initialViewport: initialViewport,
    beforeInit: beforeInit,
    mapConfig: mapConfig
  }, placeCard && /* @__PURE__ */React61.createElement(ActivityMapPlaceCard, {
    data: placeCard
  }));
};
ActivityMap.fragment = fragment27;
ActivityMap.displayName = "ActivityMap";
// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
var __Fragment25 = gql70(_templateObject69(), EGDSDialogToolbar.fragment, ActivityMap.fragment, ActivityDialogTrigger.fragment);
var ActivityLocationMapDialog = function (param) {
  var _param_data = param.data,
    dialog = _param_data.dialog,
    trigger = _param_data.trigger,
    dynamicMap = _param_data.dynamicMap;
  var closeAnalytics = dialog.closeAnalytics,
    toolbar = dialog.toolbar;
  var clickTracker = useClickTracker17();
  var dialogKey = React62.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var _useDialog7 = _sliced_to_array(useDialog7("activity-map-".concat(dialogKey)), 3),
    isDialogOpen = _useDialog7[0],
    dialogActions = _useDialog7[1],
    DialogComponent = _useDialog7[2];
  var triggerRef = React62.useRef(null);
  var toolbarAction = function () {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React62.createElement(React62.Fragment, null, /* @__PURE__ */React62.createElement(ActivityDialogTrigger, {
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React62.createElement(EGDSSheetTransition8, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React62.createElement(DialogComponent, null, /* @__PURE__ */React62.createElement(EGDSSheet5, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React62.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction: toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React62.createElement(ActivityMap, {
    data: dynamicMap
  })))));
};
ActivityLocationMapDialog.displayName = "ActivityLocationMapDialog";
ActivityLocationMapDialog.fragment = __Fragment25;
// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-action-dialog.tsx
import React63 from "react";
import { gql as gql71 } from "@apollo/client";
import { EGDSDialog as EGDSDialog3, EGDSDialogContent as EGDSDialogContent4, EGDSDialogFooter as EGDSDialogFooter3 } from "@egds/react-core/dialog";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSHeading as EGDSHeading5, EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
var fragment28 = gql71(_templateObject70());
var SignInActivityActionDialog = function (param) {
  var data = param.data,
    actionsCallback = param.actionsCallback,
    closeDialog = param.closeDialog,
    content = param.content,
    title = param.title,
    graphic = param.graphic;
  var clickstreamAnalytics = useClickTracker18();
  var buttons = data.footer.buttons;
  var triggerRef = React63.createRef();
  var handleCloseButtonClick = function () {
    closeDialog();
  };
  var handleActionButtonClick = function (url, analytics) {
    window.location.replace(url);
    clickstreamAnalytics(analytics.referrerId, analytics.linkName);
  };
  var _buttons_map = _sliced_to_array(buttons.map(function (currentButton) {
      if (currentButton.__typename === "UIPrimaryButton") {
        var primary2 = currentButton.primary;
        var primarybtn = {
          text: primary2,
          type: "primary",
          onClick: function () {
            var _currentButton_action;
            return ((_currentButton_action = currentButton.action) === null || _currentButton_action === void 0 ? void 0 : _currentButton_action.__typename) === "UILinkAction" ? handleActionButtonClick(currentButton.action.resource.value, currentButton.action.analytics) : handleCloseButtonClick();
          }
        };
        return primarybtn;
      }
      var primary = currentButton.primary;
      return {
        text: primary,
        type: "tertiary",
        onClick: function () {
          return handleCloseButtonClick();
        }
      };
    }), 3),
    buttonOne = _buttons_map[0],
    buttonTwo = _buttons_map[1],
    buttonThree = _buttons_map[2];
  return /* @__PURE__ */React63.createElement(EGDSDialog3, {
    dialogShow: true,
    returnFocusOnClose: true
  }, /* @__PURE__ */React63.createElement(EGDSDialogContent4, null, /* @__PURE__ */React63.createElement(EGDSLayoutGrid3, {
    columns: ["0.8fr", "8fr"],
    space: "one",
    justifyContent: "start"
  }, /* @__PURE__ */React63.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React63.createElement("div", null, graphic && /* @__PURE__ */React63.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React63.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React63.createElement("div", null, /* @__PURE__ */React63.createElement(EGDSHeading5, {
    size: 5
  }, title), /* @__PURE__ */React63.createElement(EGDSParagraph2, {
    key: "dialogParagraph",
    size: 2
  }, content)))), /* @__PURE__ */React63.createElement(EGDSDialogFooter3, {
    stacked: false,
    buttonOne: buttonOne,
    buttonTwo: buttonTwo
  })));
};
SignInActivityActionDialog.fragment = fragment28;
SignInActivityActionDialog.displayName = "SignInActivityActionDialog";
// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-dialog.tsx
import React64 from "react";
import { gql as gql72 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
var fragment29 = gql72(_templateObject71(), SignInActivityActionDialog.fragment);
var SignInActivityDialog = function (param) {
  var data = param.data,
    title = param.title,
    dialogId = param.dialogId,
    dialogContent = param.dialogContent,
    handleActionsCallback = param.handleActionsCallback,
    graphic = param.graphic;
  var _useDialog8 = _sliced_to_array(useDialog8(dialogId), 3),
    isDialogOpen = _useDialog8[0],
    dialogActions = _useDialog8[1],
    DialogComponent = _useDialog8[2];
  var closeDialog = function () {
    dialogActions.closeDialog();
  };
  if (!dialogContent) {
    return null;
  }
  return /* @__PURE__ */React64.createElement("div", {
    "data-stid": dialogId
  }, /* @__PURE__ */React64.createElement(EGDSSheetTransition9, {
    isVisible: true
  }, /* @__PURE__ */React64.createElement(DialogComponent, null, /* @__PURE__ */React64.createElement(SignInActivityActionDialog, {
    data: data,
    content: dialogContent,
    closeDialog: closeDialog,
    title: title,
    actionsCallback: handleActionsCallback,
    graphic: graphic
  }))));
};
SignInActivityDialog.fragment = fragment29;
SignInActivityDialog.displayName = "SignInActivityDialog";
// ../internal/src/components/activity-card/activity-card-content/activity-card-reviews-rating-content.tsx
var __Fragment26 = gql73(_templateObject72(), ActivitiesEGDSText.fragment, EGDSStylizedText.fragment, ActivityDisclaimerDialog.fragment);
var activityDialogTriggerMargin = {
  blockstart: "half"
};
var secondaryTextMargin = {
  inlinestart: "one"
};
var ActivityCardReviewsRatingContent = function (param) {
  var className = param.className,
    data = param.data;
  var primary = data.primary,
    secondaries = data.secondaries,
    disclaimer = data.disclaimer,
    reviewRatingBadge = data.reviewRatingBadge,
    reviewSuperlative = data.reviewSuperlative;
  var _ref = reviewRatingBadge || {},
    text = _ref.text,
    theme = _ref.theme,
    accessibility = _ref.accessibility,
    size = _ref.size;
  var _ref1 = reviewSuperlative || {},
    superlativeSize = _ref1.textSize;
  var getHighlightReviews = function () {
    return /* @__PURE__ */React65.createElement("div", {
      className: className
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, {
      space: "one",
      alignItems: "center"
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSBadgeStandard, {
      text: text,
      theme: theme,
      a11yText: accessibility,
      size: size
    })), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, {
      direction: "column"
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, reviewSuperlative && /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: Number(superlativeSize),
      data: reviewSuperlative
    })), (secondaries === null || secondaries === void 0 ? void 0 : secondaries.length) && secondaries.map(function (secondary, index) {
      return /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, {
        key: "activity-card-reviews-rating-content-".concat(index)
      }, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
        textSize: 200,
        data: secondary
      }));
    })))));
  };
  var getReviewsRatings = function () {
    return primary && /* @__PURE__ */React65.createElement("div", {
      className: className
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, null, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: 300,
      data: primary
    })), (secondaries === null || secondaries === void 0 ? void 0 : secondaries.length) && secondaries.map(function (secondary, index) {
      return /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, {
        key: "activity-card-reviews-rating-content-".concat(index)
      }, /* @__PURE__ */React65.createElement(EGDSSpacing14, {
        margin: secondaryTextMargin
      }, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
        textSize: 300,
        data: secondary
      })));
    }), disclaimer && /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSSpacing14, {
      margin: activityDialogTriggerMargin
    }, /* @__PURE__ */React65.createElement(ActivityDisclaimerDialog, {
      data: disclaimer
    })))));
  };
  return reviewRatingBadge ? getHighlightReviews() : getReviewsRatings();
};
ActivityCardReviewsRatingContent.displayName = "ActivityCardReviewsRatingContent";
ActivityCardReviewsRatingContent.fragment = __Fragment26;
// ../internal/src/components/activity-card/activity-card-content/activity-card-section-content.tsx
var __Fragment27 = gql74(_templateObject73(), ActivityCardTextContent.fragment, ActivityCardTextListContent.fragment, ActivityCardHeadingContent.fragment, ActivityCardReviewsRatingContent.fragment, ActivityPriceDisplay.fragment, ActivityCardLinkListContent.fragment);
var topMargin4 = {
  blockstart: "one"
};
var topMarginForOverview = {
  blockstart: "three"
};
var ActivityCardSectionContent = function (param) {
  var cardHeadingContent = param.cardHeadingContent,
    cardLinkListContent = param.cardLinkListContent,
    cardTextContent = param.cardTextContent,
    cardTextListContent = param.cardTextListContent,
    className = param.className,
    isOverviewSection = param.isOverviewSection,
    data = param.data;
  var rows = data.rows,
    columns = data.columns;
  var mapCardContentRows = function (row, key) {
    switch (row.__typename) {
      case "ActivityCardHeadingContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-heading-".concat(key),
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardHeadingContent, _object_spread_props(_object_spread({}, cardHeadingContent), {
          data: row
        })));
      case "ActivityCardLinkListContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-link-list-".concat(key),
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardLinkListContent, _object_spread_props(_object_spread({}, cardLinkListContent), {
          data: row
        })));
      case "ActivityCardTextContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-text-".concat(key),
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardTextContent, _object_spread_props(_object_spread({}, cardTextContent), {
          data: row
        })));
      case "ActivityCardTextListContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-text-list-".concat(key),
          margin: isOverviewSection ? topMarginForOverview : topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardTextListContent, _object_spread_props(_object_spread({}, cardTextListContent), {
          data: row
        })));
      case "ActivityCardReviewsRatingContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-reviews-rating-".concat(key),
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardReviewsRatingContent, {
          data: row
        }));
      case "ActivityPriceDisplay":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: "activity-card-section-content-price-display-".concat(key),
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityPriceDisplay, {
          align: EGDSPriceLockupAlign3.LEFT,
          data: row
        }));
      default:
        return null;
    }
  };
  if (columns.length) {
    return /* @__PURE__ */React66.createElement("section", {
      className: className,
      "data-stid": "activity-card-section"
    }, /* @__PURE__ */React66.createElement(EGDSLayoutGrid4, {
      columns: {
        small: 1,
        medium: columns.length
      },
      space: "six"
    }, columns.map(function (column, index) {
      return column.rows.length > 0 ? /* @__PURE__ */React66.createElement(EGDSLayoutGridItem4, {
        key: "activity-card-section-column-".concat(index)
      }, /* @__PURE__ */React66.createElement("div", null, column.rows.map(function (row) {
        return mapCardContentRows(row, index);
      }))) : null;
    })));
  }
  return rows.length ? /* @__PURE__ */React66.createElement("section", {
    className: className,
    "data-stid": "activity-card-section"
  }, rows.map(function (row, index) {
    return mapCardContentRows(row, index);
  })) : null;
};
ActivityCardSectionContent.displayName = "ActivityCardSectionContent";
ActivityCardSectionContent.fragment = __Fragment27;
// ../internal/src/components/activity-card/activity-card-content/activity-card-html-content.tsx
import React67 from "react";
import { gql as gql75 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";
var __Fragment28 = gql75(_templateObject74(), ActivitiesEGDSExpando.fragment, ActivitiesEGDSText.fragment);
var topMargin5 = {
  blockstart: "two"
};
var ActivityCardHtmlContent = function (param) {
  var className = param.className,
    headingSize = param.headingSize,
    textSize = param.textSize,
    data = param.data;
  var heading = data.heading,
    text = data.text,
    expando = data.expando;
  return /* @__PURE__ */React67.createElement("div", {
    className: className
  }, heading && /* @__PURE__ */React67.createElement(ActivitiesEGDSText, {
    headingSize: headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React67.createElement(EGDSSpacing16, {
    margin: topMargin5
  }, /* @__PURE__ */React67.createElement(ActivitiesEGDSExpando, {
    expandoPeekLines: 4,
    data: expando
  }, /* @__PURE__ */React67.createElement(EGDSUnformattedHtml, {
    htmlToParse: text
  }))) : /* @__PURE__ */React67.createElement(EGDSSpacing16, {
    margin: topMargin5
  }, /* @__PURE__ */React67.createElement(EGDSText11, {
    size: textSize
  }, /* @__PURE__ */React67.createElement(EGDSUnformattedHtml, {
    htmlToParse: text
  }))));
};
ActivityCardHtmlContent.displayName = "ActivityCardHtmlContent";
ActivityCardHtmlContent.fragment = __Fragment28;
// ../internal/src/components/activity-card/activity-image-header-card.tsx
var __Fragment29 = gql76(_templateObject75(), ActivityClickAction.fragment, ActivityCardBadges.fragment, ActivityCardSectionContent.fragment, ActivityPriceDisplay.fragment, ActivitySaveItem.fragment);
var getActivityImageHeaderCardContent = function (content, contentsLength, index) {
  switch (content.__typename) {
    case "ActivityCardSectionContent":
      return /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, {
        key: "activity-image-header-card-contents-".concat(index),
        grow: contentsLength - 1 === index ? 0 : 1
      }, /* @__PURE__ */React68.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React68.createElement(ActivityCardSectionContent, {
        data: content,
        cardHeadingContent: {
          headingSize: 7
        },
        cardLinkListContent: {
          headingSize: 8,
          orientation: "inline"
        },
        cardTextContent: {
          headingSize: 8,
          textSize: 200
        },
        cardTextListContent: {
          headingSize: 8,
          bullet: "icon-standard"
        }
      })));
    case "ActivityPriceDisplay":
      return /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, {
        key: "activity-image-header-card-contents-".concat(index),
        grow: contentsLength - 1 === index ? 0 : 1
      }, /* @__PURE__ */React68.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React68.createElement(ActivityPriceDisplay, {
        align: EGDSPriceLockupAlign4.LEFT,
        data: content
      })));
    default:
      return null;
  }
};
var ActivityImageHeaderCard = function (_param) {
  var className = _param.className,
    border = _param.border,
    tag = _param.tag,
    data = _param.data,
    attributes = _object_without_properties(_param, ["className", "border", "tag", "data"]);
  var image = data.image,
    badges = data.badges,
    contents = data.contents,
    clickAction = data.clickAction,
    saveItem = data.saveItem,
    analytics = data.analytics;
  var reactPortalContext = typeof window === "undefined" ? {
    htmlElement: void 0
  } : {
    htmlElement: document.body
  };
  return (contents === null || contents === void 0 ? void 0 : contents.length) ? /* @__PURE__ */React68.createElement(EGDSLayoutFlex10, _object_spread({
    className: className,
    tag: tag
  }, attributes), saveItem && /* @__PURE__ */React68.createElement(ReactPortalProvider, {
    reactPortalContext: reactPortalContext
  }, /* @__PURE__ */React68.createElement(ActivitySaveItem, {
    data: saveItem,
    heartLayoutPosition: {
      type: "absolute",
      position: {
        top: "zero",
        right: "zero",
        zindex: "layer3"
      }
    }
  })), /* @__PURE__ */React68.createElement(EGDSCard3, {
    border: border
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, {
    grow: 1
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlex10, {
    direction: "column"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, {
    grow: 0
  }, /* @__PURE__ */React68.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React68.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: (analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) || "",
    linkName: (analytics === null || analytics === void 0 ? void 0 : analytics.linkName) || "",
    intersectionOptions: {
      threshold: 1
    }
  }, /* @__PURE__ */React68.createElement(EGDSFigure3, {
    ratio: EGDSFigureAspectRatioType3.R16_9
  }, /* @__PURE__ */React68.createElement(EGDSImage3, {
    placeholderImage: true,
    alt: image === null || image === void 0 ? void 0 : image.description,
    src: image === null || image === void 0 ? void 0 : image.url,
    lazyLoading: "lazy"
  }))), badges && /* @__PURE__ */React68.createElement(ActivityCardBadges, {
    data: badges
  }))), contents.map(function (content, index) {
    return getActivityImageHeaderCardContent(content, contents.length, index);
  }), clickAction && /* @__PURE__ */React68.createElement(ActivityClickAction, {
    data: clickAction
  }))))) : null;
};
ActivityImageHeaderCard.displayName = "ActivityImageHeaderCard";
ActivityImageHeaderCard.fragment = __Fragment29;
// ../internal/src/components/activity-card/activity-location-card.tsx
import React69 from "react";
import { gql as gql77 } from "@apollo/client";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
var __Fragment30 = gql77(_templateObject76(), ActivitiesEGDSText.fragment, ActivityCardSectionContent.fragment, ActivityLocationMapDialog.fragment);
var topMargin6 = {
  blockstart: "three"
};
var gridColumns2 = {
  large: ["1fr", "2fr"]
};
var gridColumnsForOverview = {
  large: ["1fr"]
};
var ActivityLocationCard = function (param) {
  var _param_data = param.data,
    mapContents = _param_data.mapContents,
    heading = _param_data.heading,
    map = _param_data.map,
    ref = _param_data.ref,
    className = param.className,
    jumplinkTabRefs = param.jumplinkTabRefs,
    isOverviewSection = param.isOverviewSection;
  var sectionRef = jumplinkTabRefs ? jumplinkTabRefs[ref] : void 0;
  return /* @__PURE__ */React69.createElement(EGDSCard4, {
    className: className
  }, /* @__PURE__ */React69.createElement("div", {
    ref: sectionRef
  }, /* @__PURE__ */React69.createElement(EGDSLayoutGrid5, {
    tag: "section",
    columns: isOverviewSection ? gridColumnsForOverview : gridColumns2,
    space: "three",
    id: ref
  }, /* @__PURE__ */React69.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React69.createElement(ActivitiesEGDSText, {
    data: heading,
    headingSize: 4,
    tabIndex: -1
  })), /* @__PURE__ */React69.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(ActivityLocationMapDialog, {
    data: map
  }), mapContents.map(function (mapContent, index) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing17, {
      margin: topMargin6,
      key: "map-content-".concat(index)
    }, /* @__PURE__ */React69.createElement(ActivityCardSectionContent, {
      data: mapContent,
      cardTextListContent: {
        headingSize: 6,
        bullet: "no-bullet",
        nestedListBullet: "no-bullet"
      },
      key: index,
      isOverviewSection: isOverviewSection
    }));
  }))))));
};
ActivityLocationCard.displayName = "ActivityLocationCard";
ActivityLocationCard.fragment = __Fragment30;
// ../internal/src/components/activity-card/activity-card.tsx
var __Fragment31 = gql78(_templateObject77(), ActivityImageHeaderCard.fragment, ActivityLocationCard.fragment);
var ActivityCard = function (_param) {
  var className = _param.className,
    border = _param.border,
    data = _param.data,
    tag = _param.tag,
    jumplinkTabRefs = _param.jumplinkTabRefs,
    isOverviewSection = _param.isOverviewSection,
    attributes = _object_without_properties(_param, ["className", "border", "data", "tag", "jumplinkTabRefs", "isOverviewSection"]);
  switch (data.__typename) {
    case "ActivityImageHeaderCard":
      return /* @__PURE__ */React70.createElement(ActivityImageHeaderCard, _object_spread({
        className: className,
        border: border,
        tag: tag,
        data: data
      }, attributes));
    case "ActivityLocationCard":
      return /* @__PURE__ */React70.createElement(ActivityLocationCard, {
        data: data,
        jumplinkTabRefs: jumplinkTabRefs,
        className: className,
        isOverviewSection: isOverviewSection
      });
    default:
      return null;
  }
};
ActivityCard.displayName = "ActivityCard";
ActivityCard.fragment = __Fragment31;
// ../internal/src/components/activitiy-carousel-container/activity-carousel-container.tsx
var __Fragment32 = gql79(_templateObject78(), ActivityCard.fragment, ActivitiesEGDSHeading.fragment);
var carouselMargin = {
  blockstart: "three"
};
var ActivityCarouselContainer = function (param) {
  var className = param.className,
    itemsVisible = param.itemsVisible,
    cardsBorder = param.cardsBorder,
    data = param.data;
  var cards = data.cards,
    accessibility = data.accessibility,
    heading = data.heading;
  var _accessibility_prevButton, _accessibility_nextButton;
  return cards.length ? /* @__PURE__ */React71.createElement("div", {
    className: className
  }, heading && /* @__PURE__ */React71.createElement(ActivitiesEGDSHeading, {
    size: 4,
    data: heading
  }), /* @__PURE__ */React71.createElement(EGDSSpacing18, {
    margin: carouselMargin
  }, /* @__PURE__ */React71.createElement(EGDSCarousel, {
    itemsVisible: itemsVisible,
    pageBy: 1,
    peek: true,
    buttonText: {
      prevButton: (_accessibility_prevButton = accessibility === null || accessibility === void 0 ? void 0 : accessibility.prevButton) !== null && _accessibility_prevButton !== void 0 ? _accessibility_prevButton : "Previous",
      nextButton: (_accessibility_nextButton = accessibility === null || accessibility === void 0 ? void 0 : accessibility.nextButton) !== null && _accessibility_nextButton !== void 0 ? _accessibility_nextButton : "Next"
    },
    wrapItems: true,
    itemsMaxHeight: true
  }, cards.map(function (card, index) {
    return /* @__PURE__ */React71.createElement(ActivityCard, {
      key: index,
      border: cardsBorder,
      data: card
    });
  })))) : null;
};
ActivityCarouselContainer.displayName = "ActivityCarouselContainer";
ActivityCarouselContainer.fragment = __Fragment32;
// src/components/recommendations/recommendations.tsx
import { useBexApi } from "@shared-ui/bex-api-context";
var __Query = gql80(_templateObject79(), ActivitiesEGDSHeading.fragment, ActivityCarouselContainer.fragment);
var Recommendations = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var recommendations = data === null || data === void 0 ? void 0 : data.activityInfo.recommendations;
  if (loading || error || !recommendations) {
    return null;
  }
  return /* @__PURE__ */React72.createElement(React72.Fragment, null, recommendations.heading && /* @__PURE__ */React72.createElement(ActivitiesEGDSHeading, {
    size: 4,
    data: recommendations.heading
  }), /* @__PURE__ */React72.createElement(EGDSSpacing19, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React72.createElement(ActivityCarouselContainer, {
    data: recommendations.carousel,
    itemsVisible: {
      lg: 4,
      md: 2,
      sm: 1
    },
    cardsBorder: true
  })));
};
Recommendations.displayName = "sharedui-Recommendations";
export { Recommendations };